import React, { useEffect, useState } from 'react';

import { DataGrid } from '@mui/x-data-grid';

import EditCalendarIcon from '@mui/icons-material/EditCalendar';

import ModeEditIcon from '@mui/icons-material/ModeEdit';

import DownloadIcon from '@mui/icons-material/Download';

import InfoIcon from '@mui/icons-material/Info';

import Menu from '@mui/material/Menu';

import MenuItem from '@mui/material/MenuItem';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import {
	Box,
	Grid,
	Button,
	Select,
	InputLabel,
	Dialog,
	Typography,
	DialogTitle,
	DialogContent,
	Modal,
	Alert,
	Tooltip,
	Snackbar,
	Input,
	Autocomplete,
} from '@mui/material';

import {
	getPatientList,
	getPracticeStaff,
	putPatientDetail,
	putPatAdmData,
	postAddPatAdmData,
	getLocation,
	addAppointment,
	postUserSettings,
	getUserSettings,
	updateUserSettings,
	postPatNotes,
} from '../../../services/api/apiManager';

import Group4 from '../../../../assets/logos/Group4.png';

import DeleteIcon from '@mui/icons-material/Delete';

import FormControl from '@mui/material/FormControl';

import TextField from '@mui/material/TextField';

import { CircularProgress } from '@mui/material';

import './PatientList.css';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';

import IconButton from '@mui/material/IconButton';

import { useStateValue } from '../../../services/state/State';

import { actions } from '../../../services/state/Reducer';

import useMediaQuery from '@mui/material/useMediaQuery';

import { useTheme } from '@mui/material/styles';

import { useNavigate } from 'react-router-dom';

import {
	DateTimePicker,
	DesktopDatePicker,
	LocalizationProvider,
} from '@mui/x-date-pickers';

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';

import DomainVerificationIcon from '@mui/icons-material/DomainVerification';

import CancelIcon from '@mui/icons-material/Cancel';

import { utils, writeFile } from 'xlsx';

import Checkbox from '@mui/material/Checkbox';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import StarBorderPurple500Icon from '@mui/icons-material/StarBorderPurple500';

import AddIcon from '@mui/icons-material/Add';

import AddTaskIcon from '@mui/icons-material/AddTask';

import PersonIcon from '@mui/icons-material/Person';

const getPatientGridHeight = (rowCount, pageSize) => {
	const visibleRows = rowCount === 0 ? 0 : Math.min(rowCount, pageSize || 10, 10);
	const emptyStateHeight = rowCount === 0 ? 220 : 0;
	const headerHeight = 36;
	const footerHeight = 58;
	const borderBuffer = 2;

	return (
		headerHeight +
		(visibleRows * 35 || emptyStateHeight) +
		footerHeight +
		borderBuffer
	);
};

const patientSearchInputSx = {
	height: 40,
	border: '1px solid #d6e2f2',
	borderRadius: '6px',
	backgroundColor: '#fff',
	px: 1.5,
	fontSize: '13px',
	fontFamily: 'Poppins',
	color: '#122b55',
	boxShadow: 'none',
	'& input::placeholder': {
		color: '#7d8da8',
		opacity: 1,
	},
	'&:focus-within': {
		borderColor: '#2E68BA',
		boxShadow: 'none',
	},
};

const patientFilterControlSx = {
	minWidth: 0,
	'& .MuiInputBase-root': {
		fontSize: '13px',
		padding: 0,
	},
};

const patientFilterTextFieldSx = {
	fontFamily: 'Poppins',
	'& .MuiOutlinedInput-root': {
		height: 40,
		borderRadius: '6px',
		border: '1px solid #d6e2f2',
		backgroundColor: '#fff',
		boxShadow: 'none',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#122b55',
		'& fieldset': {
			border: '0 !important',
		},
		'& legend': {
			display: 'none',
		},
		'& input': {
			boxSizing: 'border-box',
			padding: '0 12px',
		},
		'&:hover fieldset': {
			border: '0 !important',
		},
		'&.Mui-focused fieldset': {
			border: '0 !important',
		},
		'&:hover': {
			borderColor: '#c8d5e8',
		},
		'&.Mui-focused': {
			borderColor: '#2E68BA',
		},
	},
	'& .MuiInputLabel-root': {
		fontSize: '12px',
		fontWeight: 600,
		color: '#0a234a',
		fontFamily: 'Poppins',
		transform: 'translate(0, -18px) scale(1)',
	},
	'& .MuiInputLabel-root.Mui-focused': {
		color: '#0a234a',
	},
};

const patientFilterLabelSx = {
	fontSize: '12px',
	fontWeight: 600,
	color: '#0a234a',
	mb: '6px',
	lineHeight: 1,
	fontFamily: 'Poppins',
};

const patientActionButtonSx = {
	height: 40,
	borderRadius: '6px',
	px: 2,
	fontFamily: 'Poppins',
	fontSize: '12px',
	fontWeight: 700,
	textTransform: 'capitalize',
	boxShadow: '0 2px 6px rgba(46, 104, 186, 0.25)',
};

const patientActionMenuPaperSx = {
	mt: '4px',
	width: 210,
	minWidth: 210,
	maxWidth: 210,
	borderRadius: '14px',
	border: '1px solid #eef2f7',
	boxShadow: '0 8px 20px rgba(15, 23, 42, 0.09)',
	overflow: 'visible',
	position: 'relative',
	'&::before': {
		content: '""',
		position: 'absolute',
		top: 0,
		right: 66,
		width: 12,
		height: 12,
		backgroundColor: '#fff',
		borderTop: '1px solid #eef2f7',
		borderLeft: '1px solid #eef2f7',
		transform: 'translateY(-50%) rotate(45deg)',
		zIndex: 0,
	},
	'& .MuiList-root': {
		width: 210,
		boxSizing: 'border-box',
		py: '10px',
		position: 'relative',
		zIndex: 1,
		backgroundColor: '#fff',
		borderRadius: '14px',
	},
};

const patientActionMenuItemSx = {
	minHeight: 42,
	gap: '14px',
	mx: '10px',
	px: '8px',
	py: '6px',
	borderRadius: '10px',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 600,
	color: '#1f2f46',
	lineHeight: 1.2,
	'&:hover': {
		backgroundColor: 'rgba(47, 118, 203, 0.1)',
		color: '#1f55d9',
	},
	'&.Mui-disabled': {
		opacity: 0.45,
	},
};

const patientActionMenuIconSx = {
	width: 28,
	height: 28,
	borderRadius: '8px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: 'rgba(47, 118, 203, 0.08)',
	flexShrink: 0,
	'& svg': {
		fontSize: '17px',
		color: '#2f76cb',
	},
};

const patientDeleteActionMenuItemSx = {
	...patientActionMenuItemSx,
	color: '#ff2020',
	mt: '8px',
	pt: '10px',
	borderTop: '1px solid rgba(47, 118, 203, 0.14)',
	borderTopLeftRadius: 0,
	borderTopRightRadius: 0,
	'&:hover': {
		backgroundColor: '#fff1f1',
		color: '#ff2020',
	},
};

const patientDeleteActionMenuIconSx = {
	...patientActionMenuIconSx,
	backgroundColor: 'rgba(255, 32, 32, 0.08)',
	'& svg': {
		...patientActionMenuIconSx['& svg'],
		color: '#ff2020',
	},
};

const patientModalPaperSx = {
	borderRadius: '10px',
	overflow: 'hidden',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	border: '1px solid #dce8f5',
};

const patientModalTitleSx = {
	fontFamily: 'Poppins',
	fontSize: '18px',
	fontWeight: 700,
	color: '#0b2450',
};

const patientModalLabelSx = {
	fontFamily: 'Poppins',
	fontSize: '12px',
	fontWeight: 600,
	color: '#0b2450',
	mb: 0.7,
};

const patientModalFieldSx = {
	'& .MuiOutlinedInput-root': {
		minHeight: '42px',
		borderRadius: '6px',
		fontFamily: 'Poppins',
		fontSize: '13px',
		'& fieldset': { borderColor: '#d7e3f4' },
		'&:hover fieldset': { borderColor: '#b8c9e0' },
		'&.Mui-focused fieldset': {
			borderColor: '#2f6edb',
			borderWidth: '1px',
		},
	},
	'& .MuiInputBase-input': {
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#0b2450',
	},
};

const patientModalOutlineButtonSx = {
	height: '40px',
	minWidth: '112px',
	borderRadius: '6px',
	border: '1px solid #cfd9e8',
	backgroundColor: '#fff',
	color: '#344054',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 700,
	textTransform: 'none',
	'&:hover': { backgroundColor: '#f8fafc', borderColor: '#b9c6d8' },
};

const patientModalPrimaryButtonSx = {
	height: '40px',
	minWidth: '122px',
	borderRadius: '6px',
	backgroundColor: '#2f6edb',
	color: '#fff',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 700,
	textTransform: 'none',
	boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
	'&:hover': { backgroundColor: '#245fc5' },
	'&.Mui-disabled': {
		backgroundColor: '#d7dce5',
		color: '#98a2b3',
		boxShadow: 'none',
	},
};

const patientModalHeader = (title, onClose) => (
	<Box
		sx={{
			height: 58,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			borderBottom: '1px solid #edf2f8',
			px: 2.2,
		}}
	>
		<Typography sx={patientModalTitleSx}>{title}</Typography>
		<IconButton size="small" onClick={onClose} sx={{ color: '#0b2450' }}>
			<CancelIcon sx={{ fontSize: '22px' }} />
		</IconButton>
	</Box>
);

function PatientList() {
	// Dispatch State Value
	const [{ providers }, dispatch] = useStateValue();
	const [loadingProviders, setLoadingProviders] = useState(false); // Provider loading state
	const [isProviderLoaded, setIsProviderLoaded] = useState(false);
	const [loadingLocations, setLoadingLocations] = useState(false); // Location loading state
	const [isLocationLoaded, setIsLocationLoaded] = useState(false);
	const [isFavLoaded, setIsFavLoaded] = useState(false); // Favorite loading state
	const [loadingFav, setLoadingFav] = useState(false);

	// Get Practice Id from local Storage
	const practice_id = localStorage.getItem('practice_id');

	// Get Location from location api State
	const [locationGet, setLocationGet] = React.useState([]);

	// Use Navigate Hook
	const darkNavigate = useNavigate();

	// Get Patient List Data from DataGrid State
	const [patientListData, setPatientListData] = useState([]);
	// DataGrid Loading State
	const [loading, setLoading] = useState(false);

	// Main Page Loading State
	const [mainloading, setMainloading] = useState(true);

	// set Patient Name from Datagrid to show All Modal using CellValues
	const [patName, setPatName] = React.useState('');

	// Header Search Filter & Dropdown here
	// smsm
	const [searchBy, setSearchBy] = useState('');
	const [provider, setProvider] = React.useState('');
	const [status, setStatus] = React.useState(0);
	const [location, setLocation] = React.useState('');
	const [allPatients, setAllPatients] = useState('');

	// Add Admission Modal State here
	const [providerAddAdmission, setProviderAddAdmission] = React.useState('');
	const [locationAddAdmission, setLocationAddAdmission] = React.useState('');
	const [locationNameAddAdmission, setLocationNameAddAdmission] = useState('');

	const [providerNameAddAdmission, setProviderNameAddAdmission] = useState('');

	const [patId, setPatId] = React.useState();
	const [admDate, setAdmDate] = React.useState(
		dayjs(new Date()).format('YYYY-MM-DD')
	);

	const [snackAddPatAdm, setSnackAddPatAdm] = React.useState(false);
	const [openAddPatAdm, setOpenAddPatAdm] = React.useState(false);

	// Inactive Patients Modal states here
	const [idForInactiveToActive, setIdForInactiveToAcitve] = React.useState('');
	const [dischargeDate, setDischargeDate] = React.useState(dayjs(new Date()));
	const [idForDischargeDate, setIdForDischargeDate] = React.useState('');
	const [inactivePopup, setInactivePopup] = React.useState(false);
	const [inactiveToActive, setInactiveToActive] = React.useState(false);

	// Active Patient Modal states here
	const [idForActiveStatus, setIdForActiveStatus] = React.useState('');
	const [activeInactive, setActiveInactive] = React.useState(false);
	const [checked, setChecked] = React.useState(false);
	const [activeStatus, setActiveStatus] = React.useState(false);

	// Delete Patients States here
	const [idForDelete, setIdForDelete] = React.useState('');
	const [deletePopup, setDeletePopup] = React.useState(false);

	// Favourite Patients States here
	const [patAlreadyFavList, setPatAlreadyFavList] = React.useState([]);
	const [snackAddFavPat, setSnackAddFavPat] = React.useState(false);
	const [selectedId, setSelectedId] = useState('');
	const [errorFavPatAlready, setErrorFavPatAlready] = useState([]);
	const [errorMultiPatAlready, setErrorMultiPatAlready] = useState([]);
	const [addFavListName, setAddFavListName] = useState('');
	const [settingName, setSettingName] = React.useState('');
	const [patAlreadListName, setPatAlreadListName] = React.useState(false);
	const [snackDeleteFavPat, setSnackDeleteFavPat] = React.useState(false);
	const [updateFavPatList, setUpdateFavPatList] = React.useState([]);
	const [favPatList, setFavPatList] = React.useState([]);
	const [addFavList, setAddFavList] = React.useState([]);
	const [openFavModal, setOpenFavModal] = React.useState(false);
	const [favListName, setFavListName] = React.useState();
	const [uniquePatFavName, setUniquePatFavName] = useState([]);
	const [openFavouritePatient, setOpenFavouritePatient] = React.useState(false);

	// appointments related all states are here
	const [appointmentPatientName, setAppointmentPatientName] = useState();
	const [appointmentPatientId, setAppointmentPatientId] = useState();
	const [appointmentInactiveStatus, setAppointmentInactiveStatus] = useState();
	const [appointmentProviderName, setAppointmentProviderName] = useState();
	const [selectAppointmentProvider, setSelectAppointmentProvider] =
		useState('');
	const [selectAppointmentLocation, setSelectAppointmentLocation] =
		useState('');
	const [appointmentProviderId, setAppointmentProviderId] = useState();
	const [appointmentLocationId, setAppointmentLocationId] = useState();
	const [appointmentLocationName, setAppointmentLocationName] = useState();
	const [AppointmentReason, setAppointmentReason] = useState('');
	const [selectedDate, setselectedDate] = useState(dayjs(new Date()));
	const [AppointmentPopup, setAppointmentPopup] = React.useState(false);
	const [AddAppointmentPopup, setAddAppointmentPopup] = React.useState(false);
	const [selectedValueAppointment, setSelectedValueAppointment] =
		React.useState('P');
	const [ErrorAppointmentPopup, setErrorAppointmentPopup] =
		React.useState(false);

	// Datagrid checkboxes states here
	const [selectedRows, setSelectedRows] = React.useState('');
	const [rowData, setRowData] = useState(null);
	const [inactiveMultipleRows, setInactiveMultipleRows] = useState([]);
	const [AlreadyMultipleRows, setAlreadyMultipleRows] = useState([]);
	const [selectedMultiPat, setSelectedMultiPat] = useState([]);
	const gridApiRef = React.useRef();

	// MenuItem Open States here
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [menuItemData, setMenuItemData] = React.useState('');
	const openMenuItem = Boolean(anchorEl);

	// Add charge states here
	const [inactiveAddCharge, setInactiveAddCharge] = useState();

	// Modal Popup states here
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);
	const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	// Pagination States here
	const [changePage, setChangePage] = useState({
		in_Page_Number: 0,
		in_Rows: 100,
	});
	const [paginationModel, setPaginationModel] = React.useState({
		page: 0,
		pageSize: 10,
	});

	// For MenuItem of Datagrid function here
	const handleClickMenuItem = (cellValues) => {
		setMenuItemData(cellValues);
	};
	const handleCloseMenuItem = () => {
		setAnchorEl(null);
	};

	// Action Delete Favourite Patient from Favourite List
	const handleClickFavOpen = (cellValues) => {
		setIdForDelete(cellValues?.row?.patient_id);
		setPatName(cellValues?.row?.Name);
	};

	// Action Delete Section Start
	const handleClickOpen = (cellValues) => {
		setIdForDelete(cellValues?.row?.patient_id);
		setPatName(cellValues?.row?.Name);
		setDeletePopupOpen(true);
	};
	const deleteCancelPopup = () => {
		setOpenFavouritePatient(false);
		setDeletePopupOpen(false);
		setActiveStatus(false);
		setInactiveToActive(false);
		setOpenAddPatAdm(false);
		setOpenFavModal(false);
		setChecked(false);
		setDischargeDate(dayjs(new Date()));
		setAdmDate(dayjs(new Date()).format('YYYY-MM-DD'));
		setLocationAddAdmission('');
		setProviderAddAdmission('');
		setAddFavList([]);
		setAnchorEl(null);
		setSelectedId('');
		setPatAlreadListName(false);
		setSettingName('');
		setRowData([]);
		setSelectedRows('');
		setInactiveMultipleRows([]);
		setAlreadyMultipleRows([]);
		setSelectedMultiPat([]);
	};

	// Action Status for Active to Inactive Section here
	const OpenStatus = (cellValues) => {
		setIdForDischargeDate(cellValues?.row?.admissionid);
		setIdForActiveStatus(cellValues?.row?.patient_id);
		setPatName(cellValues?.row?.Name);
		setActiveStatus(true);
	};
	const handleClose = () => {
		setOpen(false);
		setAnchorEl(null);
	};

	// Action Status for Inactive to Active
	const InactiveToActive = (cellValues) => {
		setIdForInactiveToAcitve(cellValues?.row?.patient_id);
		setPatName(cellValues?.row?.Name);
		setInactiveToActive(true);
	};

	// Action to Add Patient Admission
	const GetValueAddPatAdm = (cellValues) => {
		setLocationAddAdmission(cellValues?.row?.locationid);
		setProviderAddAdmission(cellValues?.row?.providerid);
		setPatId(cellValues?.row?.patient_id);
		setPatName(cellValues?.row?.Name);
		setOpenAddPatAdm(true);
	};

	const OpenAppointmentSchedular = (cellValues) => {
		setAppointmentPatientId(cellValues?.row?.patient_id);
		setAppointmentInactiveStatus(cellValues?.row?.Inactive);
		setAppointmentPatientName(cellValues?.row?.Name);
		setAppointmentLocationName(cellValues?.row?.location);
		setAppointmentLocationId(cellValues?.row?.locationid);
		setAppointmentProviderId(cellValues?.row?.providerid);
		setAppointmentProviderName(cellValues?.row?.provider);
		setOpen(true);
	};
	const handleCloseModal = () => {
		setOpen(false);
		setAppointmentReason('');
		setSelectedValueAppointment('P');
		setAnchorEl(null);
	};
	const handleCloseAppointment = () => {
		setOpen(false);
		setAnchorEl(null);
	};

	const handleChange = (event) => {
		setSelectedValueAppointment(event.target.value);
	};

	// handle Navigate Edit Patient from Patient_list
	const handleEditPatient = (cellValues) => {
		darkNavigate('/Edit_Patient', {
			state: {
				id: cellValues?.row?.patient_id,
				id1: cellValues?.row?.id,
				id2: cellValues?.row?.admissionid,
				id3: cellValues?.row?.LstVistId,
				insurance: cellValues?.row?.payer,
				locationId: cellValues?.row?.locationid,
				providerId: cellValues?.row?.providerid,
			},
		});
	};

	// Delete patient section start
	const data = {
		Deleted: true,
	};
	const DeleteButton = async (uid, data) => {
		const check = await putPatientDetail(uid, data);
		if (check?.request?.status === 200) {
			setLoading(true);
			setDeletePopupOpen(false);
			ShowSnackbarDelete();
			setSearchBy('');
			setProvider('');
			setStatus(0);
			setLocation('');
			setAnchorEl(null);
			setTimeout(() => {
				setDeletePopup(false);
			}, 1500);
			try {
				await showPatientListData(
					searchBy,
					location,
					status,
					provider,
					changePage
				);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setLoading(false);
			setDeletePopupOpen(false);
		}
	};

	// Activate Inactive Status here
	const dataInactiveStatus = {
		Inactive: true,
	};
	const InactiveStatus = async (status, data) => {
		const check = await putPatientDetail(status, data);
		if (check?.request?.status === 200) {
			setLoading(true);
			setStatus(0);
			setActiveStatus(false);
			ShowSnackbarActivate();
			setSearchBy('');
			setProvider('');
			setDischargeDate(dayjs(new Date()));
			setChecked(false);
			setLocation('');
			setAnchorEl(null);
			setTimeout(() => {
				setActiveInactive(false);
			}, 1500);
			try {
				await showPatientListData(searchBy, location, 0, provider, changePage);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setLoading(false);
			setActiveStatus(false);
		}
	};

	// For Discharge Date
	const year3 = new Date(dischargeDate).getFullYear();
	const month3 = (new Date(dischargeDate).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day3 = new Date(dischargeDate).getDate().toString().padStart(2, '0');
	const discharge_Date = `${year3}-${month3}-${day3}`;

	const updatePatAdmData = {
		discharge_date: `${discharge_Date}`,
	};

	const dischargeDateAdd = async (id, data) => {
		const resp = await putPatAdmData(id, data);
		if (resp?.request?.status === 200) {
			setDischargeDate(dayjs(new Date()));
			setChecked(false);
		}
	};

	const year2 = new Date(admDate).getFullYear();
	const month2 = (new Date(admDate).getMonth() + 1).toString().padStart(2, '0');
	const day2 = new Date(admDate).getDate().toString().padStart(2, '0');
	const add_Admission = `${year2}-${month2}-${day2}`;
	const PatientData = {
		practice_id: practice_id,
		patient_id: patId,
		Admission_date: `${add_Admission}`,
		Inactive: false,
		...(providerAddAdmission !== '' &&
			providerAddAdmission !== null && { provider_id: providerAddAdmission }),
		...(locationAddAdmission !== '' &&
			locationAddAdmission !== null && { location_id: locationAddAdmission }),
	};
	//ye chal raha hai is neceh wala
	const addAdmissionPatient = async (PatientData) => {
		const checkAddAdmission = await postAddPatAdmData(PatientData);
		if (checkAddAdmission?.request?.status === 200 || 201) {
			const previousLocation = menuItemData?.row?.location || null;
			const previousProvider = menuItemData?.row?.provider;
			const previousAdmissionDate =
				menuItemData?.row?.Admission_date?.split('T')[0] || null;

			const notes = [];
			if (admDate) {
				if (!previousAdmissionDate) {
					notes.push({
						NotesText: `Admission date is added: ${admDate}`,
					});
				} else if (admDate !== previousAdmissionDate) {
					notes.push({
						NotesText: `Admission date is added from ${previousAdmissionDate} to ${admDate}`,
					});
				}
			}
			if (providerNameAddAdmission) {
				if (previousProvider == ', ') {
					notes.push({
						NotesText: `Provider is added: ${providerNameAddAdmission}`,
					});
				} else if (providerAddAdmission != previousProvider) {
					notes.push({
						NotesText: `Provider is added from ${previousProvider} to ${providerNameAddAdmission}`,
					});
				}
			}
			if (locationNameAddAdmission) {
				if (previousLocation == null) {
					notes.push({
						NotesText: `Location is added: ${locationNameAddAdmission}`,
					});
				} else if (locationAddAdmission != previousLocation) {
					notes.push({
						NotesText: `Location is added from ${previousLocation} to ${locationNameAddAdmission}`,
					});
				}
			}

			if (notes?.length > 0) {
				setLoading(true);
				PatAdmActiveStatus(patId, ActiveStatusOfPatAdm);
				setOpenAddPatAdm(false);
				ShowSnackbarAddPatAdm();
				setSearchBy('');
				setProvider('');
				setAdmDate(dayjs(new Date()).format('YYYY-MM-DD'));
				setLocationAddAdmission('');
				setProviderAddAdmission('');
				setStatus(0);
				setLocation('');
				setAnchorEl(null);

				setTimeout(() => {
					setSnackAddPatAdm(false);
				}, 1500);

				const notesPayload = {
					Patientid: patId,
					practice_id: practice_id,
					NoteCategory: 'patient',
					Platform: 'web',
					Notes: notes,
				};

				try {
					await notes_PatientUpdateInformation(notesPayload);
				} catch (error) {
					console.error('Error triggering notes API:', error);
				}
			}

			try {
				await showPatientListData(
					searchBy,
					location,
					status,
					provider,
					changePage
				);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setLoading(false);
			setOpenAddPatAdm(false);
		}
	};
	const AddFavouritePatient = (cellValues) => {
		// For Multiple Ids Getting List Names
		const filterdMultiSelectedData = favPatList
			?.map((i) => {
				let filteredCodes = [];
				AlreadyMultipleRows.forEach((value) => {
					const codesMatchingValue = i?.setting_codes?.filter(
						(j) => j?.Code === value
					);
					filteredCodes = filteredCodes.concat(codesMatchingValue);
				});

				if (filteredCodes && filteredCodes?.length > 0) {
					return {
						SettingName: i?.SettingName,
						CreatedBy: i?.CreatedBy,
						ModifiedBy: i?.ModifiedBy,
						setting_codes: filteredCodes,
					};
				}

				return null;
			})
			.filter((item) => item !== null);

		// Getting Unique Name to show on Favourite List which is already on exist in list

		const filteredPatNameForFavList = filterdMultiSelectedData
			?.map((i) => {
				let matchedCodes = [];
				selectedMultiPat.forEach((patName) => {
					const codesMatchingName = i?.setting_codes?.filter(
						(code) => code?.CodeDescription === patName?.Name
					);
					matchedCodes = matchedCodes.concat(codesMatchingName);
				});
				return matchedCodes?.map((code) => code?.CodeDescription);
			})
			.filter((item) => item?.length > 0);
		// const uniquePatNames = [...new Set(filteredPatNameForFavList.flat())];
		// setUniquePatFavName(uniquePatNames);
		const uniquePatNames = [
			...new Set(
				filteredPatNameForFavList.flat().map((patName) => {
					// const nameParts = patName.split(',');
					// return `${nameParts[1].trim()}, ${nameParts[0].trim()}`;
					return patName;
				})
			),
		];
		setUniquePatFavName(uniquePatNames);

		const addSpacesToCamelCaseMultiple = (str) => {
			return str.replace(/([A-Z])/g, '$1').trim();
		};

		const formattedListNamesMultiple = filterdMultiSelectedData?.map((i) => {
			return addSpacesToCamelCaseMultiple(i?.SettingName);
		});

		const formattedListNameStringMultiple =
			formattedListNamesMultiple?.join(', ');

		// For Single Id Getting List Name

		const filteredData = favPatList
			?.map((i) => {
				const filteredCodes = i?.setting_codes?.filter((j) => {
					return j?.Code == cellValues?.row?.patient_id;
				});

				if (filteredCodes && filteredCodes?.length > 0) {
					return {
						SettingName: i?.SettingName,
						CreatedBy: i?.CreatedBy,
						ModifiedBy: i?.ModifiedBy,
						setting_codes: filteredCodes,
					};
				}

				return null;
			})
			.filter((item) => item !== null);
		const addSpacesToCamelCase = (str) => {
			return str.replace(/([A-Z])/g, '$1').trim();
		};

		const formattedListNames = filteredData?.map((i) => {
			return addSpacesToCamelCase(i?.SettingName);
		});

		const formattedListNameString = formattedListNames?.join(', ');

		if (AlreadyMultipleRows?.length > 0) {
			setPatAlreadyFavList(formattedListNameStringMultiple);
		} else {
			setPatAlreadyFavList(formattedListNameString);
		}

		setPatId(cellValues?.row?.patient_id);
		setPatName(cellValues?.row?.Name);
		setOpenFavouritePatient(true);
	};
	const dataOfFavPat = {
		practice_id: practice_id,
		Type: 'pat',
		SettingName: settingName,
		setting_codes: [],
	};

	if (rowData?.length > 0) {
		rowData.forEach((row) => {
			dataOfFavPat?.setting_codes.push({
				CodeType: 'pat',
				Code: row?.patient_id,
				CodeDescription: row?.Name,
			});
		});
	} else {
		dataOfFavPat.setting_codes.push({
			CodeType: 'pat',
			Code: patId,
			CodeDescription: patName,
		});
	}

	const addFavPat = async (dataOfFavPat) => {
		// setLoading(true);
		const checkPostFavPat = await postUserSettings(dataOfFavPat);
		if (checkPostFavPat?.request?.status === 200 || 201) {
			setLoading(true);
			setOpenFavouritePatient(false);
			setSnackAddFavPat(true);
			setSearchBy('');
			setSettingName('');
			setProvider('');
			setStatus(0);
			setLocation('');
			setFavListName(null);
			setRowData([]);
			setSelectedRows('');
			setInactiveMultipleRows([]);
			setAlreadyMultipleRows([]);
			setSelectedMultiPat([]);
			setAnchorEl(null);
			setTimeout(() => {
				setSnackAddFavPat(false);
			}, 1500);
			try {
				await getFavPatient();
				await showPatientListData(
					searchBy,
					location,
					status,
					provider,
					changePage
				);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setLoading(false);
			setOpenFavouritePatient(false);
		}
	};

	// Get Favourite Patient List API Call
	const getFavPatient = async () => {
		if (loadingFav || isFavLoaded) return;

		setLoadingFav(true);

		try {
			const resp = await getUserSettings();

			if (resp?.status === 200) {
				setMainloading(false);

				setFavPatList(
					resp?.data
						?.filter((items) => {
							return (
								items?.practice_id === parseInt(practice_id) &&
								(items?.Type === 'pat' || items?.Type === 'PAT')
							);
						})
						?.reverse()
				);

				setIsFavLoaded(true);
			}
		} catch (error) {
			setFavPatList([]);
		} finally {
			setLoadingFav(false);
		}
	};
	// Edit or Put Favourite Patient
	const putFavPat = async (id, data) => {
		// setLoading(true);
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			setLoading(true);
			setOpenFavouritePatient(false);
			setAllPatients('');
			setAddFavList([]);
			setSelectedId('');
			setSnackAddFavPat(true);
			setSearchBy('');
			setSettingName('');
			setOpenFavModal(false);
			setProvider('');
			setStatus(0);
			setFavListName(null);
			setRowData([]);
			setSelectedRows('');
			setInactiveMultipleRows([]);
			setAlreadyMultipleRows([]);
			setSelectedMultiPat([]);
			setLocation('');
			setAnchorEl(null);
			setTimeout(() => {
				setSnackAddFavPat(false);
			}, 1500);
			try {
				await getFavPatient();
				await showPatientListData(
					searchBy,
					location,
					status,
					provider,
					changePage
				);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setLoading(false);
			setOpenFavouritePatient(false);
		}
	};
	const notes_PatientUpdateInformation = async (data) => {
		try {
			const response = await postPatNotes(data);
			if (response.status === 201) {
				console.log('Status checkkkk:', response);
			}
		} catch (error) {
			console.error('Error:', error);
		}
	};
	const deleteFavPat = async (id, data) => {
		try {
			const resp = await updateUserSettings(id, data);
			if (resp?.request?.status === 200) {
				setLoading(true);
				setOpenFavouritePatient(false);
				setSnackDeleteFavPat(true);
				setOpenFavModal(false);
				setAllPatients('');
				setSearchBy('');
				setSettingName('');
				setProvider('');
				setStatus(0);
				setLocation('');
				setFavListName(null);
				setRowData([]);
				setSelectedRows('');
				setInactiveMultipleRows([]);
				setAlreadyMultipleRows([]);
				setSelectedMultiPat([]);
				setAnchorEl(null);

				setTimeout(() => {
					setSnackDeleteFavPat(false);
				}, 1500);

				// Generate the note message once
				const notesMessage = `Patient ${selectedMultiPat?.[0]?.Name || patName} has been deleted from the favorite list.`;

				// Log the note once
				await notes_PatientUpdateInformation({
					Patientid: menuItemData?.id,
					practice_id: practice_id,
					NoteCategory: 'patient',
					Platform: 'web',
					Notes: [{ NotesText: notesMessage }],
				});

				// Fetch updated patient data once
				await Promise.all([
					showPatientListData(searchBy, location, status, provider, changePage),
					getFavPatient(),
				]);
			} else {
				setLoading(false);
				setOpenFavouritePatient(false);
			}
		} catch (error) {
			console.error('Error in deleteFavPat:', error);
		}
	};

	// Add patient Admission to Active Its Status
	const ActiveStatusOfPatAdm = {
		Inactive: null,
	};
	const PatAdmActiveStatus = async (patId, ActiveStatusOfPatAdm) => {
		const resp = await putPatientDetail(patId, ActiveStatusOfPatAdm);
	};

	// Activate Active Status here
	const dataActiveStatus = {
		Inactive: false,
	};

	const ActiveStatus = async (status, data) => {
		const check = await putPatientDetail(status, data);
		if (check?.request?.status === 200) {
			setLoading(true);
			setInactiveToActive(false);
			ShowSnackbarInactive();
			setSearchBy('');
			setProvider('');
			setStatus(0);
			setLocation('');
			setAnchorEl(null);
			setTimeout(() => {
				setInactivePopup(false);
			}, 1500);
			try {
				await showPatientListData(searchBy, location, 0, provider, changePage);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setLoading(false);
			setInactiveToActive(false);
		}
	};

	// DropDown filter section here
	const filteredOutData = patientListData
		?.map((rowData, index) => ({ id: index, ...rowData }))
		?.filter((item) => {
			// if (searchBy !== '') {
			// 	return (
			// 		// (allPatients === '' ||
			// 		// 	allPatients
			// 		// 		?.map((patient) => patient?.Code)
			// 		// 		.includes(item?.patient_id)) &&
			// 		// item?.Name.toLowerCase().includes(searchBy.toLowerCase()) &&
			// 		// (status == 'Active'
			// 		// 	? item?.Inactive == null || item?.Inactive == false
			// 		// 	: status == '' || item?.Inactive == true)
			// 		(allPatients === '' ||
			// 			allPatients
			// 				?.map((patient) => patient?.Code)
			// 				.includes(item?.patient_id)) &&
			// 		(item?.Name.toLowerCase().includes(searchBy.toLowerCase()) ||
			// 			item?.Name.toLowerCase().includes(
			// 				searchBy.toLowerCase().replace(/\s/g, ', ')
			// 			) ||
			// 			item?.Name.toLowerCase()
			// 				.replace(/,\s*/g, ',')
			// 				.includes(searchBy.toLowerCase().replace(/,\s*/g, ','))) &&
			// 		(status == 'Active'
			// 			? item?.Inactive == null || item?.Inactive == false
			// 			: status == '' || item?.Inactive == true)
			// 	);
			// } else {
			return (
				allPatients === '' ||
				allPatients?.map((patient) => patient?.Code).includes(item?.patient_id)
				// 		&&
				// (status == 'Active'
				// 	? item?.Inactive == null || item?.Inactive == false
				// 	: status == '' || item?.Inactive == true)
			);
		});

	// Get patient list Section start
	const showPatientListData = async (
		searchBy,
		location,
		status,
		provider,
		changePage
	) => {
		try {
			setMainloading(false);
			setLoading(true);
			const response = await getPatientList(
				practice_id,
				'0',
				searchBy != '' ? searchBy : undefined,
				provider != '' ? provider : undefined,
				location != '' ? location : undefined,
				status !== '' ? status : undefined,
				changePage?.in_Rows.toString()
			);
			if (response?.status === 200) {
				setPatientListData(response?.data);
				// setPatientListData(response?.data.reverse());
				dispatch({ type: actions.SET_PATIENTS, payload: response?.data });
			} else {
				setPatientListData([]);
				dispatch({ type: actions.SET_PATIENTS, payload: [] });
			}
			setLoading(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			setLoading(false);
		}
	};
	// Get Provider dropdown Section start
	const showPracticeData = async () => {
		if (loadingProviders || isProviderLoaded) return;

		setLoadingProviders(true);
		try {
			const response = await getPracticeStaff();

			if (response?.status === 200) {
				dispatch({
					type: actions.SET_PROVIDERS,
					payload: response?.data || [],
				});
			} else {
				dispatch({
					type: actions.SET_PROVIDERS,
					payload: [],
				});
			}

			setIsProviderLoaded(true);
		} catch (error) {
			dispatch({
				type: actions.SET_PROVIDERS,
				payload: [],
			});
		} finally {
			setLoadingProviders(false);
		}
	};

	// Get Location dropdown Section start
	const getLocationData = async () => {
		if (loadingLocations || isLocationLoaded) return;

		setLoadingLocations(true);
		try {
			const resp = await getLocation();
			setLocationGet(resp?.data || []);
			setIsLocationLoaded(true);
		} catch (error) {
			setLocationGet([]);
		} finally {
			setLoadingLocations(false);
		}
	};

	// Modal Part for appointment patient
	const openPopup = () => {
		setAppointmentPopup(true);
	};
	const closePopup = () => {
		setAppointmentPopup(false);
	};

	const appointmentData = {
		AppointmentDate: new Date(selectedDate).toISOString(),
		Reason: AppointmentReason,
		Status: selectedValueAppointment,
		patient_id: appointmentPatientId,
		provider_id:
			appointmentProviderId === null
				? selectAppointmentProvider
				: appointmentProviderId,
		// ...(appointmentProviderId && { provider_id: appointmentProviderId }),
		// ...(appointmentLocationId && { location_id: appointmentLocationId }),
		location_id:
			appointmentLocationId === null
				? selectAppointmentLocation
				: appointmentLocationId,
	};

	const SubmitAppointment = async (e) => {
		e.preventDefault();
		const resp = await addAppointment(appointmentData);

		if (resp?.request?.status === 201 || resp?.request?.status === 200) {
			const currentDateTime = new Date().toLocaleString();
			const successMessage = `Appointment created successfully on ${currentDateTime}`;

			notes_PatientUpdateInformation({
				Patientid: menuItemData?.id,
				practice_id: practice_id,
				NoteCategory: 'patient',
				Platform: 'web',
				Notes: [
					{
						NotesText: successMessage,
					},
				],
			});

			setLoading(true);
			setAppointmentPopup(false);
			setOpen(false);
			ShowSnackbarAppointment();
			setStatus(0);
			setAnchorEl(null);
			setTimeout(() => {
				setAddAppointmentPopup(false);
			}, 1500);

			try {
				await showPatientListData(
					searchBy,
					location,
					status,
					provider,
					changePage
				);
			} catch (error) {
				console.error('Error fetching data:', error);
			}

			setAppointmentReason('');
			setselectedDate(dayjs(new Date()));
		} else {
			setErrorAppointmentPopup(true);
			setLoading(false);
			setAppointmentPopup(false);
			setOpen(false);
			setAppointmentReason('');
			setAnchorEl(null);
			setTimeout(() => {
				setErrorAppointmentPopup(false);
			}, 1500);
		}
	};

	// Appointment Modal Style Section Start
	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		background: 'white',
		fontFamily: 'Poppins',
		borderRadius: '10px',
		width: 'min(900px, calc(100vw - 32px))',
		boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
		border: '1px solid #dce8f5',
		outline: 'none',
		overflow: 'hidden',
	};

	// Snackbars Section start
	const ShowSnackbarActivate = () => {
		setActiveInactive(true);
	};
	const CancelSnackbarActivate = () => {
		setActiveInactive(false);
	};
	const ShowSnackbarAddPatAdm = () => {
		setSnackAddPatAdm(true);
	};
	const CancelSnackbarAddPatAdm = () => {
		setSnackAddPatAdm(false);
	};
	const CancelSnackbarAddFavPat = () => {
		setSnackAddFavPat(false);
	};
	const CancelSnackbarDeleteFavPat = () => {
		setSnackDeleteFavPat(false);
	};
	const ShowSnackbarAppointment = () => {
		setAddAppointmentPopup(true);
	};
	const CancelSnackbarAppointment = () => {
		setAddAppointmentPopup(false);
	};
	const ShowSnackbarDelete = () => {
		setDeletePopup(true);
	};
	const CancelSnackbarDelete = () => {
		setDeletePopup(false);
	};
	const ShowSnackbarInactive = () => {
		setInactivePopup(true);
	};
	const CancelSnackbarInactive = () => {
		setInactivePopup(false);
	};

	// UseEffect function here
	useEffect(() => {
		if (rowData && rowData?.length > 0) {
			const inactiveRows = rowData.filter((i) => i?.Inactive === true);
			setInactiveMultipleRows(inactiveRows);
		} else {
			setInactiveMultipleRows([]);
		}
		if (rowData && rowData?.length > 0) {
			const ActiveRows = rowData.filter((i) => i?.Inactive !== true);
			setSelectedMultiPat(ActiveRows);
			const GetPatId = ActiveRows?.map((i) => i?.patient_id);
			setAlreadyMultipleRows(GetPatId);
		} else {
			setAlreadyMultipleRows([]);
		}
	}, [rowData]);
	// smsm
	useEffect(() => {
		showPatientListData(searchBy, location, status, provider, changePage);
	}, [location, status, provider, changePage, searchBy]);

	// Download CSV file
	const downloadCSV = () => {
		const columns = [
			[
				'Patient Id',
				'Patient Name',
				'Provider Name',
				'MRN',
				'Room',
				'Adm Date',
				'Location Name',
				'Insurance Name',
				'Status',
			],
		];
		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);
		utils.sheet_add_aoa(worksheet, columns);
		patientListData
			?.filter((data) => selectedRows.includes(data?.patient_id))
			?.forEach((item, index) => {
				utils.sheet_add_json(
					worksheet,
					[
						[
							item?.patient_id,
							item?.Name == ', ' ? '' : item?.Name?.split(', ')?.join(', '),
							item?.provider == ', '
								? ''
								: item?.provider?.split(', ')?.join(', '),
							item?.MRN,
							item?.Room_No,
							dayjs(item?.Admission_date).format('MM-DD-YYYY'),
							item?.location,
							item?.payer,
							item?.Inactive === null
								? 'Active'
								: item?.Inactive === false
									? 'Active'
									: item?.Inactive === true
										? 'Inactive'
										: '',
						],
					],
					{ origin: `A${index + 2}`, skipHeader: true }
				);
			});
		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Patient List Report.xlsx');
		showPatientListData(searchBy, location, status, provider, changePage);
		setSelectedRows('');
	};

	// Data Grid Column Section Start
	const columns = [
		{
			field: 'patient_id',
			headerName: 'Patient ID',
			flex: 1,
			minWidth: 140,
		},
		{
			field: 'Name',
			headerName: 'Patient',
			flex: 1,
			minWidth: 120,
			renderCell: (cellValues) => {
				const nameParts = cellValues?.value;
				return (
					<div>
						<p
							style={{ cursor: 'pointer' }}
							onClick={() => {
								handleEditPatient(cellValues);
							}}
						>
							<u>{nameParts}</u>&nbsp;
							{cellValues?.row?.admissionid === null && (
								<Tooltip
									arrow
									title={
										cellValues?.row?.admissionid === null
											? 'Admission not Created'
											: 'Admission Created'
									}
									placement="top-start"
								>
									<InfoIcon fontSize="small" sx={{ color: 'red' }} />
								</Tooltip>
							)}
						</p>
					</div>
				);
			},
		},
		{
			field: 'DOB',
			headerName: 'DOB',
			flex: 0.8,
			minWidth: 100,
			renderCell: (params) => {
				return (
					<span
						style={{
							width: '100%',
						}}
					>
						{dayjs(params?.row?.DOB)?.format('MM/DD/YYYY') === 'Invalid Date'
							? ''
							: dayjs(params?.row?.DOB)?.format('MM/DD/YYYY')}
					</span>
				);
			},
		},
		{
			field: 'provider',
			headerName: 'Provider',
			flex: 1,
			minWidth: 130,
			renderCell: (params) => {
				const provider = params.value;
				if (!provider || provider.trim() === ',') {
					return (
						<span
							style={{
								display: 'inline-block',
								width: '100%',
								marginLeft: '2rem',
							}}
						>
							{'-'}
						</span>
					);
				}
				return provider;
			},
		},
		{
			field: 'MRN',
			flex: 0.7,
			minWidth: 100,
			headerName: 'MRN',
		},
		{
			field: 'Room_No',
			headerName: 'Room',
			flex: 0.5,
			minWidth: 110,
			renderCell: (params) => {
				const Room_No = params?.value;
				return Room_No ? (
					Room_No
				) : (
					<span
						style={{
							display: 'inline-block',
							width: '100%',
							marginLeft: '1.2rem',
						}}
					>
						-
					</span>
				);
			},
		},
		{
			field: 'Admission_date',
			headerName: 'Adm Date',
			flex: 0.5,
			minWidth: 135,
			valueGetter: (params) => {
				if (params?.row?.Admission_date) {
					return dayjs(params?.row?.Admission_date).format('MM/DD/YYYY');
				} else {
					return '';
				}
			},
			renderCell: (params) => {
				const Admission_date = params?.value;
				return Admission_date ? (
					Admission_date
				) : (
					<span
						style={{
							display: 'inline-block',
							width: '100%',
							marginLeft: '2.3rem',
						}}
					>
						-
					</span>
				);
			},
		},
		{
			field: 'location',
			headerName: 'Location',
			flex: 1,
			minWidth: 130,
		},
		{
			field: 'payer',
			headerName: 'Insurance',
			flex: 1,
			minWidth: 140,
		},
		{
			field: 'Inactive',
			headerName: 'Status',
			flex: 0.5,
			minWidth: 115,
			renderCell: (params) => {
				const cellStyle =
					params?.row?.Inactive === null || params?.row?.Inactive === false
						? { color: '#076714' }
						: { color: '#C90D0D' };
				return (
					<Box style={cellStyle}>
						{params?.row?.Inactive === null
							? 'Active'
							: params?.row?.Inactive === false
								? 'Active'
								: params?.row?.Inactive === true
									? 'Inactive'
									: params?.row?.Inactive?.toString()}
					</Box>
				);
			},
		},
		{
			field: 'Action',
			headerName: 'Action',
			sortable: false,
			disableColumnMenu: true,
			renderCell: (cellValues) => {
				return (
					<Box display={'flex'} alignItems={'center'}>
						{allPatients != '' ? (
							<MenuItem>
								<IconButton
									onClick={(event) => {
										handleClickFavOpen(cellValues);
										setOpenFavModal(true);
									}}
									aria-label="Edit"
									size="small"
								>
									<StarBorderPurple500Icon
										style={{
											color: allPatients != '' ? 'orange' : '#43618C',
											cursor: 'pointer',
											fontSize: '16px',
										}}
									/>
								</IconButton>
							</MenuItem>
						) : (
							''
						)}
						<IconButton
							onClick={(event) => {
								handleClickMenuItem(cellValues);
								setInactiveAddCharge(cellValues?.row?.Inactive);
								setAnchorEl(event.currentTarget);
							}}
						>
							<MoreVertIcon />
						</IconButton>
						<Menu
							anchorEl={anchorEl}
							open={openMenuItem}
							onClose={handleCloseMenuItem}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'center',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'center',
							}}
							PaperProps={{
								sx: patientActionMenuPaperSx,
							}}
						>
							<MenuItem
								disabled={inactiveAddCharge === true}
								sx={patientActionMenuItemSx}
								onClick={() => {
									darkNavigate('/newCharge', {
										state: { patient_id: menuItemData?.row?.patient_id },
									});
									setAnchorEl(null);
								}}
							>
								<Box sx={patientActionMenuIconSx}>
									<AddTaskIcon />
								</Box>
								Add Charge
							</MenuItem>
							{/* <MenuItem
								disabled={inactiveAddCharge === true}
								sx={{ height: '20px' }}
							>
								<IconButton
									onClick={() => {
										AddFavouritePatient(menuItemData);
										setAnchorEl(null);
									}}
									aria-label="Edit"
									size="small"
								>
									<StarBorderPurple500Icon
										style={{
											color: allPatients != '' ? 'orange' : '#43618C',
											cursor: 'pointer',
											fontSize: '14px',
										}}
									/>
									&nbsp;
									<span
										style={{
											fontSize: '11px',
											fontFamily: 'Poppins',
											fontWeight: '600',
											color: 'black',
										}}
									>
										Add Favourite
									</span>
								</IconButton>
							</MenuItem> */}
							<MenuItem
								disabled={inactiveAddCharge === true}
								sx={patientActionMenuItemSx}
								onClick={() => {
									AddFavouritePatient(menuItemData);
									// const patientName = menuItemData?.row?.Name;
									// const patientId = menuItemData?.row?.Patientid;
									// const visitId = menuItemData?.row?.Visit_id;

									notes_PatientUpdateInformation({
										Patientid: menuItemData?.id,
										practice_id: practice_id,
										NoteCategory: 'patient',
										Platform: 'web',
										Notes: [
											{
												NotesText: `${menuItemData?.row?.Name} has been added to Favorite list`,
											},
										],
									});

									setAnchorEl(null);
								}}
							>
								<Box sx={patientActionMenuIconSx}>
									<StarBorderPurple500Icon />
								</Box>
								Add Favourite
							</MenuItem>
							<MenuItem
								disabled={inactiveAddCharge === true}
								sx={patientActionMenuItemSx}
								onClick={() => {
									OpenAppointmentSchedular(menuItemData);
									setAnchorEl(null);
								}}
							>
								<Box sx={patientActionMenuIconSx}>
									<EditCalendarIcon />
								</Box>
								Add Appointment
							</MenuItem>
							<MenuItem
								sx={patientActionMenuItemSx}
								onClick={() => {
									GetValueAddPatAdm(menuItemData);
									setAnchorEl(null);
								}}
							>
								<Box sx={patientActionMenuIconSx}>
									<AddCircleOutlineIcon />
								</Box>
								Add Admission
							</MenuItem>
							<MenuItem
								sx={patientActionMenuItemSx}
								onClick={() => {
									handleEditPatient(menuItemData);
									setAnchorEl(null);
								}}
							>
								<Box sx={patientActionMenuIconSx}>
									<ModeEditIcon />
								</Box>
								Edit Patient
							</MenuItem>
							<MenuItem
								sx={patientActionMenuItemSx}
								onClick={() => {
									// const patientName = menuItemData?.row?.Name;
									// const patientId = menuItemData?.row?.Patientid;
									setPatName(menuItemData?.row?.Name);

									if (menuItemData?.row?.Inactive === true) {
										InactiveToActive(menuItemData);
										notes_PatientUpdateInformation({
											Patientid: menuItemData?.id,
											practice_id: practice_id,
											NoteCategory: 'patient',
											Platform: 'web',
											Notes: [
												{
													NotesText: `${menuItemData?.row?.Name} is now marked as Active Patient`,
												},
											],
										});
									} else {
										OpenStatus(menuItemData);
										notes_PatientUpdateInformation({
											Patientid: menuItemData?.id,
											practice_id: practice_id,
											NoteCategory: 'patient',
											Platform: 'web',
											Notes: [
												{
													NotesText: `${menuItemData?.row?.Name} is now marked as Inactive Patient`,
												},
											],
										});
									}

									setAnchorEl(null);
								}}
							>
								{/* <IconButton
									onClick={() => {
										
										setPatName(menuItemData?.row?.Name);
										if (menuItemData?.row?.Inactive === true) {
											InactiveToActive(menuItemData);
											setAnchorEl(null);
										} else {
											OpenStatus(menuItemData);
											setAnchorEl(null);
										}
									}}
									size="small"
								>
									<DomainVerificationIcon
										style={{
											color: '#43618C',
											cursor: 'pointer',
											fontSize: '14px',
										}}
									/>
									&nbsp;
									<span
										style={{
											fontSize: '11px',
											fontFamily: 'Poppins',
											fontWeight: '600',
											color: 'black',
										}}
									>
										{menuItemData?.row?.Inactive === true
											? 'Active Patient'
										: 'Inactive Patient'}
									</span>
								</IconButton> */}
								<Box sx={patientActionMenuIconSx}>
									<DomainVerificationIcon />
								</Box>
								{menuItemData?.row?.Inactive === true
									? 'Active Patient'
									: 'Inactive Patient'}
							</MenuItem>
							<MenuItem
								sx={patientDeleteActionMenuItemSx}
								onClick={() => {
									handleClickOpen(menuItemData);
									setAnchorEl(null);
								}}
							>
								<Box sx={patientDeleteActionMenuIconSx}>
									<DeleteIcon />
								</Box>
								Delete Patient
							</MenuItem>
						</Menu>
					</Box>
				);
			},
		},
	];

	const patientGridRows =
		allPatients === ''
			? patientListData?.map((rowData, index) => ({
				id: index,
				...rowData,
			}))
			: filteredOutData;
	const patientGridHeight = getPatientGridHeight(
		patientGridRows?.length || 0,
		paginationModel.pageSize
	);

	return (
		<>
			<Box
				sx={{
					width: '100%',
					maxWidth: '100%',
					boxSizing: 'border-box',
					overflowX: 'hidden',
					px: { xs: '8px', md: '16px' },
					pb: 2,
				}}
			>
				{mainloading ? (
					<BrandedLoader
						title="Loading patients"
						text="Preparing your patient list"
					/>
				) : (
					<>
						<Box
							sx={{
								py: '12px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								gap: 2,
								flexWrap: 'wrap',
							}}
						>
							<Grid container columnSpacing={1} rowSpacing={1.5} alignItems="center">
								<Grid item xl={8} lg={8} md={8} sm={12} xs={12} >
									<Box
										sx={{
											display: 'flex',
											gap: 1.5,
											alignItems: 'flex-start',
											flexWrap: { xs: 'wrap', lg: 'nowrap' },
											'& > *': {
												flex: { xs: '1 1 100%', sm: '1 1 220px', lg: '0 0 auto' },
											},
										}}
									>
										<Box
											sx={{
												flex: {
													xs: '1 1 100%',
													sm: '1 1 220px',
													lg: '0 0 210px !important',
												},
											}}
										>
											<Typography
												sx={{
													fontSize: '12px',
													fontWeight: 600,
													color: '#0a234a',
													mb: '6px',
													lineHeight: 1,
												}}
											>
												Patient
											</Typography>
											<Input
												disableUnderline
												autoComplete="off"
												onChange={(e) => {
													setSearchBy(e.target.value);
												}}
												value={searchBy}
												sx={{ ...patientSearchInputSx, width: '100%' }}
												id="outlined-basic"
												variant="outlined"
												placeholder="Search Patient Name"
												size="small"
											/>
										</Box>
										{/* Location Filter */}
										<FormControl
											fullWidth
											size="small"
											sx={{ ...patientFilterControlSx, width: { lg: 180 } }}
										>
											<Typography sx={patientFilterLabelSx}>Provider</Typography>
											<Autocomplete
												id="provider-autocomplete"
												options={providers || []}
												getOptionLabel={(option) =>
													`${option?.Lname}, ${option?.Fname}` || ''
												}
												value={
													providers?.find((item) => item?.id === provider) ||
													null
												}
												onChange={(event, newValue) => {
													setProvider(newValue ? newValue?.id : '');
												}}
												ListboxProps={{
													sx: {
														fontSize: 11,
														color: 'black',
														fontWeight: 500,
													},
												}}
												loading={loadingProviders}
												onOpen={showPracticeData}
												noOptionsText={
													loadingProviders ? (
														<Box
															display="flex"
															alignItems="center"
															gap={1}
															p={1}
														>
															<CircularProgress size={16} />
															<Typography fontSize={12}>Loading...</Typography>
														</Box>
													) : (
														'No options'
													)
												}
												sx={{
													'& .MuiAutocomplete-endAdornment': {
														'& .MuiAutocomplete-clearIndicator': {
															'& .MuiSvgIcon-root': {
																marginRight: '-6px',
																fontSize: '15px',
																marginTop: '2px',
															},
															'&:hover': {
																backgroundColor: 'transparent',
																boxShadow: 'none',
															},
														},
													},
													'& .MuiButtonBase-root': {
														'& .MuiSvgIcon-root': {
															marginRight: '-5px',
														},
														'&:hover': {
															backgroundColor: 'transparent',
															boxShadow: 'none',
														},
													},
													'& .MuiInputLabel-root': {
														fontSize: '12px',
														marginTop: '-.5px',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														placeholder="Select provider"
														variant="outlined"
														size="small"
														sx={patientFilterTextFieldSx}
													/>
												)}
											/>
										</FormControl>
										{/* Status Filter */}
										<FormControl
											fullWidth
											size="small"
											sx={{ ...patientFilterControlSx, width: { lg: 150 } }}
										>
											<Typography sx={patientFilterLabelSx}>Status</Typography>
											<Autocomplete
												id="status-autocomplete"
												selected={status?.id == 0}
												options={[
													{ id: '', label: 'Clear Filter' },
													{ id: 0, label: 'Active' },
													{ id: 1, label: 'Inactive' },
												]}
												getOptionLabel={(option) => option.label || ''}
												value={
													status !== ''
														? {
															id: status,
															label: status === 0 ? 'Active' : 'Inactive',
														}
														: null
												}
												onChange={(event, newValue) => {
													setStatus(newValue ? newValue?.id : '');
												}}
												ListboxProps={{
													sx: {
														fontSize: 11,
														color: 'black',
														fontWeight: 500,
													},
												}}
												sx={{
													'& .MuiAutocomplete-endAdornment': {
														'& .MuiAutocomplete-clearIndicator': {
															'& .MuiSvgIcon-root': {
																marginRight: '-6px',
																fontSize: '15px',
																marginTop: '2px',
															},
															'&:hover': {
																backgroundColor: 'transparent',
																boxShadow: 'none',
															},
														},
													},

													'& .MuiButtonBase-root': {
														'& .MuiSvgIcon-root': {
															marginRight: '-5px',
														},
														'&:hover': {
															backgroundColor: 'transparent',
															boxShadow: 'none',
														},
													},
													'& .MuiInputLabel-root': {
														fontSize: '12px',
														marginTop: '-.5px',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														placeholder="Select status"
														variant="outlined"
														size="small"
														sx={patientFilterTextFieldSx}
													/>
												)}
											/>
										</FormControl>
										{/* Location Filter */}
										<FormControl
											fullWidth
											size="small"
											sx={{ ...patientFilterControlSx, width: { lg: 180 } }}
										>
											<Typography sx={patientFilterLabelSx}>Location</Typography>
											<Autocomplete
												id="location-autocomplete"
												options={locationGet || []}
												getOptionLabel={(option) => option?.Name || ''}
												value={
													locationGet?.find((item) => item?.id === location) ||
													null
												}
												onChange={(event, newValue) => {
													setLocation(newValue ? newValue?.id : '');
												}}
												ListboxProps={{
													sx: {
														fontSize: 11,
														color: 'black',
														fontWeight: 500,
													},
												}}
												// onOpen={getLocationData}

												loading={loadingLocations}
												onOpen={getLocationData}
												noOptionsText={
													loadingLocations ? (
														<Box
															display="flex"
															alignItems="center"
															gap={1}
															p={1}
														>
															<CircularProgress size={16} />
															<Typography fontSize={12}>Loading...</Typography>
														</Box>
													) : (
														'No options'
													)
												}
												sx={{
													'& .MuiAutocomplete-endAdornment': {
														'& .MuiAutocomplete-clearIndicator': {
															'& .MuiSvgIcon-root': {
																marginRight: '-6px',
																fontSize: '15px',
																marginTop: '2px',
															},
															'&:hover': {
																backgroundColor: 'transparent',
																boxShadow: 'none',
															},
														},
													},
													'& .MuiButtonBase-root': {
														'& .MuiSvgIcon-root': {
															marginRight: '-5px',
														},
														'&:hover': {
															backgroundColor: 'transparent',
															boxShadow: 'none',
														},
													},
													'& .MuiInputLabel-root': {
														fontSize: '12px',
														marginTop: '-.5px',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														placeholder="Select location"
														variant="outlined"
														size="small"
														sx={patientFilterTextFieldSx}
													/>
												)}
											/>
										</FormControl>
										{/* All Patient Filter */}
										<FormControl
											fullWidth
											size="small"
											sx={{ ...patientFilterControlSx, width: { lg: 180 } }}
										>
											<Typography sx={patientFilterLabelSx}>All Patients</Typography>
											<Autocomplete
												id="all-patients-autocomplete"
												options={[
													...favPatList.filter(
														(items) => items?.setting_codes?.length > 0
													),
												]}
												getOptionLabel={(option) => option?.SettingName || ''}
												value={favListName || null}
												onChange={(event, newValue) => {
													if (newValue && newValue?.setting_codes) {
														setAllPatients(newValue?.setting_codes);
														setFavListName(newValue);
														setRowData([]);
														setSelectedRows('');
														setInactiveMultipleRows([]);
														setAlreadyMultipleRows([]);
														setSelectedMultiPat([]);
													} else {
														setAllPatients('');
														setFavListName(null);
														setRowData([]);
														setSelectedRows('');
														setInactiveMultipleRows([]);
														setAlreadyMultipleRows([]);
														setSelectedMultiPat([]);
													}
												}}
												loading={loadingFav}
												onOpen={getFavPatient}
												noOptionsText={
													loadingFav ? (
														<Box
															display="flex"
															justifyContent="center"
															alignItems="center"
															p={1}
														>
															<CircularProgress size={18} />
														</Box>
													) : (
														'No options'
													)
												}
												ListboxProps={{
													sx: {
														fontSize: 11,
														color: 'black',
														fontWeight: 500,
													},
												}}
												sx={{
													'& .MuiAutocomplete-endAdornment': {
														'& .MuiAutocomplete-clearIndicator': {
															'& .MuiSvgIcon-root': {
																marginRight: '-6px',
																fontSize: '15px',
																marginTop: '2px',
															},
															'&:hover': {
																backgroundColor: 'transparent',
																boxShadow: 'none',
															},
														},
													},
													'& .MuiButtonBase-root': {
														'& .MuiSvgIcon-root': {
															marginRight: '-5px',
														},
														'&:hover': {
															backgroundColor: 'transparent',
															boxShadow: 'none',
														},
													},
													'& .MuiInputLabel-root': {
														fontSize: '11px',
														marginTop: '.5px',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														placeholder="Select list"
														variant="outlined"
														size="small"
														sx={patientFilterTextFieldSx}
													/>
												)}
											/>
										</FormControl>
									</Box>
								</Grid>
								<Grid item xl={4} lg={4} md={4} sm={12} xs={12} >
									<Box
										sx={{
											display: 'flex',
											gap: 1.5,
											justifyContent: { xs: 'flex-start', lg: 'flex-end' },
											flexWrap: 'wrap',
											mt: '18px',
										}}
									>
										<Button
											sx={{
												...patientActionButtonSx,
												backgroundColor: '#eef2f7',
												color: '#7b8797',
												boxShadow: 'none',
												'&:hover': {
													backgroundColor: '#e2e8f0',
													boxShadow: 'none',
												},
												'&.Mui-disabled': {
													backgroundColor: '#eef2f7',
													color: '#7b8797',
												},
											}}
											variant="contained"
											disabled={selectedRows?.length === 0 ? true : false}
											onClick={() => {
												downloadCSV();
											}}
										>
											<Box
												display={'flex'}
												alignItems={'center'}
												gap={1}
												sx={{ fontSize: '12px', fontWeight: 700 }}
											>
												<DownloadIcon
													style={{
														color:
															selectedRows?.length === 0 ? '#3327' : 'white',
														cursor: 'pointer',
														fontSize: '20px',
													}}
												/>
												Export Patient
											</Box>
										</Button>
										<Button
											sx={{
												...patientActionButtonSx,
												backgroundColor: '#2E68BA',
												color: '#fff',
												'&:hover': {
													backgroundColor: '#24589f',
													boxShadow: '0 2px 6px rgba(46, 104, 186, 0.25)',
												},
											}}
											variant="contained"
											// size="small"
											onClick={() => {
												darkNavigate('/Add_Patient');
											}}
										>
											<Box display={'flex'} alignItems={'center'} gap={1}>
												<img src={Group4} width="18px" />
												Add Patient
											</Box>
										</Button>
									</Box>
								</Grid>
							</Grid>
						</Box>

						{/* datagrid */}

						<Box
							sx={{
								height: patientGridHeight,
								width: '100%',
								maxWidth: '100%',
								boxSizing: 'border-box',
								overflowX: 'auto',
								overflowY: 'hidden',
								border: '1px solid #e6edf7',
								borderRadius: '6px',
								backgroundColor: '#fff',
							}}
						>
							<DataGrid
								// rows={patientListData}
								rows={patientGridRows}
								rowHeight={35}
								columnHeaderHeight={35}
								loading={loading === true ? <CircularProgress /> : null}
								columns={columns}
								checkboxSelection
								rowSelectionModel={loading ? '' : selectedRows}
								onRowSelectionModelChange={(id) => {
									setSelectedRows(id);

									// For Added Multiple Favourite Patients Data clicking on check Box

									// if (id?.length > 0) {
									// 	const selectedRowData = id?.map((i) =>
									// 		gridApiRef.current.getRow(i)
									// 	);
									// 	setRowData(selectedRowData);
									// } else {
									// 	setRowData(null);
									// }
								}}
								apiRef={gridApiRef}
								getRowId={(row) => row?.patient_id}
								disableRowSelectionOnClick
								paginationModel={paginationModel}
								rowCount={
									// patientListData?.length !== 0
									// 	? patientListData[0]?.TotalRows
									// 	: [0]
									allPatients?.length !== 0
										? allPatients?.length
										: patientListData?.length !== 0
											? patientListData[0]?.TotalRows
											: [0]
								}
								onPaginationModelChange={(e) => {
									setPaginationModel({
										page: e.page,
										pageSize: e.pageSize,
									});
									if (
										paginationModel.page != 0 &&
										paginationModel.pageSize === 10 &&
										paginationModel.page % 9 === 0
									) {
										setChangePage((prev) => {
											return {
												in_Page_Number: prev.in_Page_Number + 1,
												in_Rows: prev.in_Rows + 100,
											};
										});
									} else if (
										(paginationModel.page == 0 || paginationModel.page !== 0) &&
										paginationModel.pageSize === 100
									) {
										setChangePage((prev) => {
											return {
												in_Page_Number: prev.in_Page_Number + 1,
												in_Rows: prev.in_Rows + 100,
											};
										});
									} else if (
										paginationModel.page != 0 &&
										paginationModel.pageSize === 25 &&
										paginationModel.page % 3 === 0
									) {
										setChangePage((prev) => {
											return {
												in_Page_Number: prev.in_Page_Number + 1,
												in_Rows: prev.in_Rows + 100,
											};
										});
									} else if (
										paginationModel.page != 0 &&
										paginationModel.pageSize === 50 &&
										paginationModel.page % 1 === 0
									) {
										setChangePage((prev) => {
											return {
												in_Page_Number: prev.in_Page_Number + 1,
												in_Rows: prev.in_Rows + 100,
											};
										});
									}
								}}
								pageSizeOptions={[10, 25, 50, 100]}
								sx={{
									border: 0,
									minWidth: '1180px',
									fontFamily: 'Poppins',
									color: '#172d58',
									'& .MuiDataGrid-columnHeader': {
										backgroundColor: '#f7f9fc',
										color: '#172d58',
										fontFamily: 'Poppins',
										fontWeight: 700,
										fontSize: '12px',
										overflow: 'hidden',
										'.MuiSvgIcon-root': {
											color: '#60739d',
										},
									},
									'& .MuiDataGrid-columnHeaders': {
										borderBottom: '1px solid #e6edf7',
									},
									'& .MuiDataGrid-cell': {
										borderBottom: '1px solid #edf2f8',
										fontFamily: 'Poppins',
										fontSize: '12px',
										fontWeight: 500,
										color: '#172d58',
										outline: 'none',
									},
									'& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus': {
										outline: 'none',
									},
									'& .MuiDataGrid-row:hover': {
										backgroundColor: '#f8fbff',
									},
									'& .MuiDataGrid-footerContainer': {
										justifyContent: 'flex-end',
										backgroundColor: '#fff',
										borderTop: '1px solid #e6edf7',
										minHeight: '56px',
										px: 2,
										fontFamily: 'Poppins',
										fontSize: '12px',
										color: '#172d58',
									},
									'& .MuiTablePagination-root': {
										fontFamily: 'Poppins',
										color: '#172d58',
									},
									'& .MuiTablePagination-toolbar': {
										minHeight: '56px',
										gap: '8px',
										px: 0,
									},
									'& .MuiInputBase-root': {
										border: '1px solid #dfe7f3',
										width: '58px',
										height: '34px',
										borderRadius: '6px',
										backgroundColor: 'white',
										fontFamily: 'Poppins',
										fontSize: '12px',
									},
									'& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
										fontFamily: 'Poppins',
										fontSize: '12px',
										color: '#172d58',
										fontWeight: 600,
									},
									'& .MuiIconButton-root': {
										color: '#1f66ff',
									},
									'& .MuiTablePagination-actions': {
										display: 'flex',
										gap: '8px',
										ml: 1,
									},
									'& .MuiTablePagination-actions .MuiIconButton-root': {
										width: 34,
										height: 34,
										border: '1px solid #e4ebf6',
										borderRadius: '50%',
										backgroundColor: '#fff',
										color: '#1f66ff',
										p: 0,
									},
									'& .MuiTablePagination-actions .MuiIconButton-root:hover': {
										backgroundColor: '#f4f8ff',
									},
									'& .MuiIconButton-root.Mui-disabled': {
										color: '#b9c7dc',
									},
									'& .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled': {
										color: '#b9c7dc',
										borderColor: '#e4ebf6',
										backgroundColor: '#fff',
									},
									'& .MuiDataGrid-virtualScroller': {
										scrollbarWidth: 'thin',
									},
									'& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
										width: '6px',
										height: '6px',
									},
									'& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
										backgroundColor: '#c7d4e8',
										borderRadius: '999px',
									},
								}}
							/>
						</Box>
					</>
				)}

				{/* Delete Dialogue for Cancel & Yes */}
				<Dialog
					fullScreen={fullScreen}
					open={deletePopupOpen}
					onClose={handleClose}
					aria-labelledby="responsive-dialog-title"
					PaperProps={{
						sx: {
							...patientModalPaperSx,
							width: 'min(410px, calc(100vw - 32px))',
							m: 0,
						},
					}}
				>
					<Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '12px 12px 0' }}>
						<IconButton size="small" onClick={deleteCancelPopup} sx={{ color: '#64748b' }}>
							<CancelIcon sx={{ fontSize: '20px' }} />
						</IconButton>
					</Box>
					<DialogContent sx={{ px: 3, pt: 1, pb: 3, textAlign: 'center' }}>
						<Box
							sx={{
								width: 74,
								height: 74,
								borderRadius: '50%',
								background: '#fff1f2',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								mx: 'auto',
								mb: 2,
							}}
						>
							<Box
								sx={{
									width: 52,
									height: 52,
									borderRadius: '50%',
									background: '#ffe4e6',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<DeleteIcon sx={{ color: '#ef4444', fontSize: '28px' }} />
							</Box>
						</Box>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 500,
								fontSize: '15px',
								color: '#1f2937',
								mb: 1,
							}}
						>
							Are you sure you want to delete this patient?
						</Typography>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 700,
								fontSize: '14px',
								color: '#005eff',
								lineHeight: 1.45,
								wordBreak: 'break-word',
							}}
						>
							{patName}
						</Typography>
					</DialogContent>
					<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, px: 3, py: 2.5, borderTop: '1px solid #edf2f8' }}>
						<Button
							onClick={deleteCancelPopup}
							startIcon={<CancelIcon sx={{ fontSize: '18px' }} />}
							sx={{ ...patientModalOutlineButtonSx, minWidth: 0, color: '#ef4444', '&:hover': { background: '#fff5f5', borderColor: '#fecaca' } }}
						>
							No
						</Button>
						<Button
							startIcon={<DomainVerificationIcon sx={{ fontSize: '18px' }} />}
							sx={{ ...patientModalPrimaryButtonSx, minWidth: 0 }}
							onClick={() => {
								DeleteButton(idForDelete, data);
							}}
							autoFocus
						>
							Yes
						</Button>
					</Box>
				</Dialog>

				{/* Delete Favourite Patient For List Cancel & Yes */}
				<Dialog
					fullScreen={fullScreen}
					open={openFavModal}
					onClose={handleClose}
					aria-labelledby="responsive-dialog-title"
					PaperProps={{
						style: { borderRadius: 8 },
					}}
				>
					<DialogTitle id="responsive-dialog-title">
						<Grid container>
							<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: '600',
										fontSize: '32',
										textAlign: 'center',
									}}
								>
									Confirmation
								</Typography>
							</Grid>
						</Grid>
						<Box sx={{ textAlign: 'right', marginTop: '-1.5rem' }}>
							<CancelIcon
								sx={{
									fontSize: '24px',
									color: 'red',
									cursor: 'pointer',
								}}
								onClick={deleteCancelPopup}
							/>
						</Box>
					</DialogTitle>
					<DialogContent>
						<Typography
							textAlign="center"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: '500',
								fontSize: '24',
							}}
						>
							{' '}
							Do you want to delete{' '}
							<span
								style={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '16px',
									color: '#075AD7',
								}}
							>
								{AlreadyMultipleRows?.length > 1
									? selectedMultiPat?.map((i, index) => {
										// const [lastName, firstName] = i?.Name.split(', ');
										// const formattedName = `${firstName.trim()}, ${lastName.trim()}`;
										return (
											<span key={index}>
												{i?.Name}

												{index !== selectedMultiPat?.length - 1 ? ' - ' : ''}
											</span>
										);
									})
									: patName}
							</span>{' '}
							from this{' '}
							<span
								style={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '16px',
									color: '#075AD7',
								}}
							>
								{favListName?.SettingName}
							</span>
							?
						</Typography>
						<br />
						<Grid container spacing={2} align="center">
							<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
								<Button
									style={{ backgroundColor: '#ED2828', width: '75%' }}
									variant="contained"
									size="small"
									autoFocus
									onClick={deleteCancelPopup}
								>
									No
								</Button>
							</Grid>
							<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
								<Button
									style={{ backgroundColor: '#FD7702', width: '75%' }}
									variant="contained"
									size="small"
									onClick={async () => {
										const check = favListName?.setting_codes?.filter((item) => {
											if (AlreadyMultipleRows?.length > 0) {
												return !AlreadyMultipleRows.includes(item?.Code);
											} else {
												return item?.Code != idForDelete;
											}
										});

										await deleteFavPat(favListName?.id, {
											setting_codes: check,
										});

										const notesMessage =
											AlreadyMultipleRows?.length > 1
												? `Patients ${selectedMultiPat?.map((p) => p?.Name).join(', ')} have been deleted from the favorite list.`
												: `Patient ${patName} has been deleted from the favorite list.`;

										await notes_PatientUpdateInformation({
											Patientid: idForDelete,
											practice_id: practice_id,
											NoteCategory: 'patient',
											Platform: 'web',
											Notes: [{ NotesText: notesMessage }],
										});

										// Close the modal and perform cleanup
										setOpenFavModal(false);
									}}
									autoFocus
								>
									Yes
								</Button>
							</Grid>
						</Grid>
					</DialogContent>
				</Dialog>

				{/* Dialogue of Status Active to Inactive Status for Cancel & Yes */}

				<Dialog
					fullScreen={fullScreen}
					open={activeStatus}
					onClose={handleClose}
					aria-labelledby="responsive-dialog-title"
					PaperProps={{
						sx: {
							...patientModalPaperSx,
							width: 'min(500px, calc(100vw - 32px))',
							m: 0,
						},
					}}
				>
					{patientModalHeader('Confirmation', deleteCancelPopup)}
					<DialogContent sx={{ px: 3, pt: 3, pb: 2.2 }}>
						<Box
							sx={{
								width: 66,
								height: 66,
								borderRadius: '50%',
								backgroundColor: '#fff7ed',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								mx: 'auto',
								mb: 2,
							}}
						>
							<PersonIcon sx={{ color: '#f97316', fontSize: '30px' }} />
						</Box>
						<Typography
							textAlign="center"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 500,
								fontSize: '15px',
								color: '#1f2937',
								mb: 1,
							}}
						>
							Do you want to mark this patient as inactive?
						</Typography>
						<Typography
							textAlign="center"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 700,
								fontSize: '14px',
								color: '#005eff',
								lineHeight: 1.45,
								wordBreak: 'break-word',
								mb: 2,
							}}
						>
							{patName}
						</Typography>
						<Box
							sx={{
								display: 'flex',
								alignItems: { xs: 'flex-start', sm: 'center' },
								flexDirection: { xs: 'column', sm: 'row' },
								gap: 1.3,
								backgroundColor: '#f8fafc',
								border: '1px solid #edf2f8',
								borderRadius: '8px',
								p: 1.5,
							}}
						>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
								<Checkbox
									size="small"
									sx={{ p: 0.2 }}
									onChange={(e) => {
										setChecked(e.target.checked);
									}}
								/>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 600,
										fontSize: '13px',
										color: '#0b2450',
										whiteSpace: 'nowrap',
									}}
								>
									Discharge Patient?
								</Typography>
							</Box>

							{checked && (
								<Box sx={{ flex: 1, width: '100%' }}>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DesktopDatePicker
											size="small"
											slotProps={{ textField: { size: 'small', fullWidth: true } }}
											sx={patientModalFieldSx}
											name="dischargeDate"
											value={dischargeDate}
											onChange={(e) => {
												setDischargeDate(e);
											}}
										/>
									</LocalizationProvider>
								</Box>
							)}
						</Box>
					</DialogContent>
					<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, px: 3, py: 2, borderTop: '1px solid #edf2f8' }}>
						<Button
							startIcon={<CancelIcon sx={{ fontSize: '18px' }} />}
							sx={{ ...patientModalOutlineButtonSx, minWidth: 0 }}
							variant="contained"
							size="small"
							autoFocus
							onClick={deleteCancelPopup}
						>
							No
						</Button>
						<Button
							startIcon={<DomainVerificationIcon sx={{ fontSize: '18px' }} />}
							sx={{ ...patientModalPrimaryButtonSx, minWidth: 0 }}
							variant="contained"
							size="small"
							onClick={() => {
								InactiveStatus(idForActiveStatus, dataInactiveStatus);
								if (checked === true) {
									dischargeDateAdd(idForDischargeDate, updatePatAdmData);
								}
							}}
							autoFocus
						>
							Yes
						</Button>
					</Box>
				</Dialog>

				{/* Dialogue of Status  Inactive to Active  Status for Cancel & Yes */}

				<Dialog
					fullScreen={fullScreen}
					open={inactiveToActive}
					onClose={handleClose}
					aria-labelledby="responsive-dialog-title"
					PaperProps={{
						sx: {
							...patientModalPaperSx,
							width: 'min(420px, calc(100vw - 32px))',
							m: 0,
						},
					}}
				>
					{patientModalHeader('Confirmation', deleteCancelPopup)}
					<DialogContent sx={{ px: 3, pt: 3, pb: 2 }}>
						<Box
							sx={{
								width: 66,
								height: 66,
								borderRadius: '50%',
								backgroundColor: '#ecfdf3',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								mx: 'auto',
								mb: 2,
							}}
						>
							<PersonIcon sx={{ color: '#16a34a', fontSize: '30px' }} />
						</Box>
						<Typography
							textAlign="center"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 500,
								fontSize: '15px',
								color: '#1f2937',
								mb: 1,
							}}
						>
							Do you want to mark this patient as active?
						</Typography>
						<Typography
							textAlign="center"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 700,
								fontSize: '14px',
								color: '#005eff',
								lineHeight: 1.45,
								wordBreak: 'break-word',
							}}
						>
							{patName}
						</Typography>
					</DialogContent>
					<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, px: 3, py: 2, borderTop: '1px solid #edf2f8' }}>
						<Button
							startIcon={<CancelIcon sx={{ fontSize: '18px' }} />}
							sx={{ ...patientModalOutlineButtonSx, minWidth: 0 }}
							variant="contained"
							size="small"
							autoFocus
							onClick={deleteCancelPopup}
						>
							No
						</Button>
						<Button
							startIcon={<DomainVerificationIcon sx={{ fontSize: '18px' }} />}
							sx={{ ...patientModalPrimaryButtonSx, minWidth: 0 }}
							variant="contained"
							size="small"
							onClick={() => {
								ActiveStatus(idForInactiveToActive, dataActiveStatus);
							}}
							autoFocus
						>
							Yes
						</Button>
					</Box>
				</Dialog>

				<Box sx={{ display: 'none' }}>
					<Dialog
						fullScreen={fullScreen}
						open={false}
						onClose={handleClose}
						aria-labelledby="responsive-dialog-title"
						PaperProps={{
							style: { borderRadius: 8 },
						}}
					>
						<DialogTitle id="responsive-dialog-title">
							<Grid container>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12} align="left">
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontWeight: '600',
											fontSize: '32',
										}}
									>
										{' '}
										Confirmation
									</Typography>
								</Grid>
							</Grid>
							<Box
								sx={{
									textAlign: 'right',
									marginTop: '-1.7rem',
									marginRight: '-10px',
								}}
							>
								<CancelIcon
									sx={{
										fontSize: '24px',
										color: 'red',
										cursor: 'pointer',
									}}
									onClick={deleteCancelPopup}
								/>
							</Box>
						</DialogTitle>
						<DialogContent>
							<Typography
								textAlign="center"
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '500',
									fontSize: '24',
								}}
							>
								{' '}
								Do you want to Inactive this patient -{' '}
								<span
									style={{
										fontFamily: 'Poppins',
										fontWeight: '600',
										fontSize: '16px',
										color: '#075AD7',
									}}
								>
									{patName}
									{/* {patName &&
									`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
								</span>{' '}
								?
							</Typography>
							<Box
								sx={{
									display: 'flex',
									alignItems: 'center',
									gap: '10px',
								}}
							>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: '450px',
										fontSize: '16px',
									}}
								>
									Discharge Patient ?
								</Typography>
								<Checkbox
									onChange={(e) => {
										setChecked(e.target.checked);
									}}
								/>

								{checked && (
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DemoContainer
											components={['DatePicker', 'DesktopDatePicker']}
										>
											<DemoItem>
												<DesktopDatePicker
													// disablePast
													size="small"
													slotProps={{ textField: { size: 'small' } }}
													sx={{
														width: '230px',
														marginLeft: '10px',
													}}
													name="dischargeDate"
													label={
														<Box sx={{ display: 'flex', alignItems: 'center' }}>
															Discharge Date
														</Box>
													}
													value={dischargeDate}
													onChange={(e) => {
														setDischargeDate(e);
													}}
												/>
											</DemoItem>
										</DemoContainer>
									</LocalizationProvider>
								)}
							</Box>

							<br />
							<Grid container spacing={2} align="center">
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
									<Button
										style={{ backgroundColor: '#ED2828', width: '75%' }}
										variant="contained"
										size="small"
										autoFocus
										onClick={deleteCancelPopup}
									>
										No
									</Button>
								</Grid>
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
									<Button
										style={{ backgroundColor: '#FD7702', width: '75%' }}
										variant="contained"
										size="small"
										onClick={() => {
											InactiveStatus(idForActiveStatus, dataInactiveStatus);
											if (checked === true) {
												dischargeDateAdd(idForDischargeDate, updatePatAdmData);
											}
										}}
										autoFocus
									>
										Yes
									</Button>
								</Grid>
							</Grid>
						</DialogContent>
					</Dialog>

					{/* Dialogue of Status  Inactive to Active  Status for Cancel & Yes */}

					<Dialog
						fullScreen={fullScreen}
						open={false}
						onClose={handleClose}
						aria-labelledby="responsive-dialog-title"
						PaperProps={{
							style: { borderRadius: 8 },
						}}
					>
						<DialogTitle id="responsive-dialog-title">
							<Grid container>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12} align="left">
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontWeight: '600',
											fontSize: '32',
										}}
									>
										{' '}
										Confirmation
									</Typography>
								</Grid>
							</Grid>
							<Box
								sx={{
									textAlign: 'right',
									marginTop: '-1.7rem',
									marginRight: '-10px',
								}}
							>
								<CancelIcon
									sx={{
										fontSize: '24px',
										color: 'red',
										cursor: 'pointer',
									}}
									onClick={deleteCancelPopup}
								/>
							</Box>
						</DialogTitle>
						<DialogContent>
							<Typography
								textAlign="center"
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '500',
									fontSize: '24',
								}}
							>
								{' '}
								Do you want to Active this patient -{' '}
								<span
									style={{
										fontFamily: 'Poppins',
										fontWeight: '600',
										fontSize: '16px',
										color: '#075AD7',
									}}
								>
									{patName}
									{/* {patName &&
									`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
								</span>{' '}
								?
							</Typography>
							<br />
							<Grid container spacing={2} align="center">
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
									<Button
										style={{ backgroundColor: '#ED2828', width: '75%' }}
										variant="contained"
										size="small"
										autoFocus
										onClick={deleteCancelPopup}
									>
										No
									</Button>
								</Grid>
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
									<Button
										style={{ backgroundColor: '#FD7702', width: '75%' }}
										variant="contained"
										size="small"
										onClick={() => {
											ActiveStatus(idForInactiveToActive, dataActiveStatus);
										}}
										autoFocus
									>
										Yes
									</Button>
								</Grid>
							</Grid>
						</DialogContent>
					</Dialog>
				</Box>

				{/* Dialogue For Add patient Admission */}

				<Dialog
					fullScreen={fullScreen}
					open={openAddPatAdm}
					onClose={handleClose}
					aria-labelledby="responsive-dialog-title"
					PaperProps={{
						sx: {
							...patientModalPaperSx,
							width: 'min(620px, calc(100vw - 32px))',
							m: 0,
						},
					}}
				>
					{patientModalHeader('Add Admission', deleteCancelPopup)}
					<DialogContent sx={{ p: 2.4 }}>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 600,
								color: '#64748b',
								mb: 2,
							}}
						>
							Patient:{' '}
							<Box component="span" sx={{ color: '#005eff', fontWeight: 700 }}>
								{patName}
							</Box>
						</Typography>
						<Box
							sx={{
								display: 'grid',
								gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
								gap: 1.6,
							}}
						>
							<Box>
								<Typography sx={patientModalLabelSx}>Provider</Typography>
								<FormControl fullWidth size="small" sx={patientModalFieldSx}>
									<Select
										name="providerSelect"
										displayEmpty
										value={providerAddAdmission}
										onChange={(e) => {
											const selectedId = e.target.value;

											const selectedProvider = providers?.find(
												(provider) => provider.id === selectedId
											);

											setProviderAddAdmission(selectedId);
											setProviderNameAddAdmission(
												selectedProvider?.Fname && selectedProvider?.Lname
													? `${selectedProvider.Fname}, ${selectedProvider.Lname}`
													: ''
											);
										}}
										inputProps={{ 'aria-label': 'Without label' }}
										MenuProps={{
											PaperProps: {
												style: {
													maxHeight: '200px',
													overflowY: 'auto',
												},
											},
										}}
									>
										<MenuItem value={''}>Select provider</MenuItem>

										{providers?.map((items) => {
											return (
												<MenuItem value={items?.id} key={items?.id}>
													{items?.Fname + ',' + items?.Lname}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Box>
							<Box>
								<Typography sx={patientModalLabelSx}>Location</Typography>
								<FormControl fullWidth size="small" sx={patientModalFieldSx}>
									<Select
										name="locationSelect"
										displayEmpty
										value={locationAddAdmission}
										onChange={(e) => {
											const selectedId = e.target.value;
											const selectedLocation = locationGet.find(
												(location) => location.id === selectedId
											);
											setLocationAddAdmission(selectedId);
											setLocationNameAddAdmission(selectedLocation?.Name || '');
										}}
										inputProps={{ 'aria-label': 'Without label' }}
										MenuProps={{
											PaperProps: {
												style: {
													maxHeight: '200px',
													overflowY: 'auto',
												},
											},
										}}
									>
										<MenuItem value={''}>Select location</MenuItem>
										{locationGet?.map((items, i) => {
											return (
												<MenuItem value={items?.id} key={i}>
													{items?.Name}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Box>
						</Box>
						<Box sx={{ mt: 1.8 }}>
							<Typography sx={patientModalLabelSx}>Admission Date</Typography>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DesktopDatePicker
									size="small"
									slotProps={{ textField: { size: 'small', fullWidth: true } }}
									sx={patientModalFieldSx}
									name="admDate"
									value={dayjs(admDate)}
									onChange={(newDate) => {
										setAdmDate(dayjs(newDate).format('YYYY-MM-DD'));
									}}
								/>
							</LocalizationProvider>
						</Box>
					</DialogContent>
					<Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, borderTop: '1px solid #edf2f8', px: 2.4, py: 1.5 }}>
						<Button
							startIcon={<CancelIcon sx={{ fontSize: '18px' }} />}
							sx={patientModalOutlineButtonSx}
							autoFocus
							onClick={deleteCancelPopup}
						>
							Cancel
						</Button>
						<Button
							startIcon={<AddIcon sx={{ fontSize: '18px' }} />}
							sx={patientModalPrimaryButtonSx}
							onClick={() => {
								addAdmissionPatient(PatientData);
							}}
							autoFocus
						>
							Add
						</Button>
					</Box>
				</Dialog>

				{/* Dialogue For Add Favourite Patient */}

				<Dialog
					fullScreen={fullScreen}
					open={openFavouritePatient}
					onClose={handleClose}
					aria-labelledby="responsive-dialog-title"
					PaperProps={{
						sx: {
							...patientModalPaperSx,
							width: 'min(560px, calc(100vw - 32px))',
							m: 0,
						},
					}}
				>
					{patientModalHeader('Add Favourite', deleteCancelPopup)}
					<DialogContent sx={{ p: 2.4 }}>
						{!selectedMultiPat?.length > 0 && patAlreadyFavList?.length > 0 && (
							<Box
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '12px',
									textAlign: 'center',
									backgroundColor: '#fff5f5',
									border: '1px solid #fecaca',
									borderRadius: '6px',
									color: '#991b1b',
									p: 1,
									mb: 1.5,
								}}
							>
								<span style={{ color: 'red' }}>
									{' '}
									{/* {patName &&
										`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
									{patName}
								</span>{' '}
								is already in
								<span style={{ color: 'red' }}> {patAlreadyFavList}</span> Lists
							</Box>
						)}
						{selectedMultiPat?.length > 0 &&
							!patAlreadyFavList?.length == 0 && (
								<Box
									sx={{
										fontFamily: 'Poppins',
										fontWeight: '600',
										fontSize: '12px',
										textAlign: 'center',
										backgroundColor: '#fff5f5',
										border: '1px solid #fecaca',
										borderRadius: '6px',
										color: '#991b1b',
										p: 1,
										mb: 1.5,
									}}
								>
									<span style={{ color: 'red' }}>
										{' '}
										{uniquePatFavName?.map((i, index) => (
											<span key={index}>
												{i}
												{index !== uniquePatFavName?.length - 1 ? ' - ' : ''}
											</span>
										))}
									</span>{' '}
									is already in
									<span style={{ color: 'red' }}>
										{' '}
										{patAlreadyFavList}
									</span>{' '}
									Lists
								</Box>
							)}
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontWeight: '500',
								fontSize: '13px',
								color: '#64748b',
								textAlign: 'left',
								mb: 1.8,
							}}
						>
							Please Choose the list name where you&apos;d like to add this
							patient !
						</Typography>
						<Typography sx={patientModalLabelSx}>Choose List</Typography>
						<FormControl
							fullWidth
							size="small"
							sx={patientModalFieldSx}
						>
							<Select
								name="addFavList"
								displayEmpty
								value={addFavList[0]?.SettingName}
								onChange={(e) => {
									setSelectedId(e.target.value);
									setAddFavList(
										favPatList?.filter((items) => items?.id == e.target.value)
									);
									const check = favPatList?.filter(
										(items) => items?.id == e.target.value
									);
									setAddFavListName(check[0]?.SettingName);
									const validationData = check[0]?.setting_codes?.filter(
										(i) => {
											return i?.Code == patId;
										}
									);
									const ValidMultipleId = check[0]?.setting_codes?.filter(
										(settingCode) => {
											return AlreadyMultipleRows.some(
												(alreadyMultipleRow) =>
													settingCode?.Code === alreadyMultipleRow
											);
										}
									);
									setErrorMultiPatAlready(ValidMultipleId);
									setErrorFavPatAlready(validationData);
									// if (rowData?.length > 0) {
									// 	rowData.forEach((i) => {
									// 		setUpdateFavPatList((prevList) =>
									// 			prevList.concat({
									// 				setting_id: e.target.value,
									// 				CodeType: 'pat',
									// 				Code: i?.patient_id,
									// 				CodeDescription: i?.Name,
									// 			})
									// 		);
									// 	});
									// } else {
									// 	setUpdateFavPatList(
									// 		check[0]?.setting_codes?.concat({
									// 			setting_id: e.target.value,
									// 			CodeType: 'pat',
									// 			Code: patId,
									// 			CodeDescription: patName,
									// 		})
									// 	);
									// }
									if (rowData?.length > 0) {
										const updatedList = [];

										rowData.forEach((i) => {
											const newEntry = {
												setting_id: e.target.value,
												CodeType: 'pat',
												Code: i?.patient_id,
												CodeDescription: i?.Name,
											};

											updatedList.push(newEntry);
										});

										setUpdateFavPatList(() => {
											const combinedList = [
												...(check[0]?.setting_codes || []),
												...updatedList,
											];

											const uniqueEntries = new Map();
											combinedList.forEach((entry) => {
												uniqueEntries.set(entry.Code, entry);
											});

											return Array.from(uniqueEntries.values());
										});
									} else {
										setUpdateFavPatList(() => [
											...(check[0]?.setting_codes || []),
											{
												setting_id: e.target.value,
												CodeType: 'pat',
												Code: patId,
												CodeDescription: patName,
											},
										]);
									}
								}}
								inputProps={{ 'aria-label': 'Without label' }}
								MenuProps={{
									PaperProps: {
										style: {
											maxHeight: '200px',
											overflowY: 'auto',
											scrollbarWidth: 'thin',
											scrollbarColor: 'dark',
											msOverflowStyle: 'none',
											WebkitOverflowScrolling: 'touch',
										},
									},
								}}
							>
								<MenuItem value={''}>Clear Filter</MenuItem>
								{favPatList?.map((items, i) => {
									return (
										<MenuItem value={items?.id} key={i}>
											{items?.SettingName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
						<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
							<Button
								disabled={
									addFavList?.length > 0 &&
										errorFavPatAlready?.length === 0 &&
										errorMultiPatAlready?.length === 0 &&
										!inactiveAddCharge === true &&
										!inactiveMultipleRows?.length > 0
										? false
										: true
								}
								sx={{ ...patientModalPrimaryButtonSx, minWidth: '104px' }}
								variant="contained"
								onClick={() => {
									putFavPat(selectedId, { setting_codes: updateFavPatList });
								}}
							>
								Add
							</Button>
						</Box>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, my: 2 }}>
							<Box sx={{ height: '1px', flex: 1, backgroundColor: '#edf2f8' }} />
							<Typography sx={{ fontSize: '12px', color: '#64748b', fontFamily: 'Poppins' }}>
								or
							</Typography>
							<Box sx={{ height: '1px', flex: 1, backgroundColor: '#edf2f8' }} />
						</Box>
						<Box>
							<Typography sx={patientModalLabelSx}>Create New List</Typography>
							<TextField
								sx={patientModalFieldSx}
								value={settingName}
								fullWidth
								size="small"
								placeholder="List Name"
								name="settingName"
								onChange={(e) => {
									const value = e.target.value;
									const favPatListName = favPatList?.find((i) => {
										return i?.SettingName == e.target.value.toLowerCase();
									});
									if (favPatListName) {
										setPatAlreadListName(true);
									} else {
										setPatAlreadListName(false);
									}
									setSettingName(value);
								}}
								required
								variant="outlined"
								id="outlined-basic"
							/>
							<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
								<Button
									disabled={
										settingName?.length > 0 &&
											!inactiveAddCharge === true &&
											!patAlreadListName &&
											!inactiveMultipleRows?.length > 0
											? false
											: true
									}
									sx={patientModalPrimaryButtonSx}
									variant="contained"
									onClick={() => {
										addFavPat(dataOfFavPat);
									}}
								>
									<Box display={'flex'} alignItems={'center'}>
										<IconButton size="small">
											<AddIcon sx={{ fontSize: '18px', mr: 0.7 }}
												style={{
													color:
														settingName?.length == 0 ||
															(inactiveAddCharge == true &&
																inactiveMultipleRows?.length > 0) ||
															patAlreadListName == true
															? '#3327'
															: 'white',
												}}
											/>
										</IconButton>
										Create New List
									</Box>
								</Button>
							</Box>
						</Box>
						<Box
							sx={{
								display:
									(errorFavPatAlready?.length !== 0 &&
										errorMultiPatAlready?.length === 0 &&
										selectedId != '' &&
										!inactiveAddCharge === true &&
										!inactiveMultipleRows?.length > 0) ||
										(patAlreadListName === true &&
											errorFavPatAlready?.length == 0) ||
										(errorMultiPatAlready?.length !== 0 &&
											selectedId != '' &&
											!inactiveMultipleRows?.length > 0) ||
										(inactiveAddCharge === true &&
											!inactiveMultipleRows?.length > 0) ||
										inactiveMultipleRows?.length > 0
										? 'block'
										: 'none',
								backgroundColor: '#fff5f5',
								border: '1px solid #fecaca',
								borderRadius: '6px',
								color: '#b42318',
								fontSize: '12px',
								fontFamily: 'Poppins',
								fontWeight: '600',
								marginTop: '1rem',
								width: '100%',
								textAlign: 'center',
								p: 1,
							}}
						>
							{errorFavPatAlready?.length !== 0 &&
								errorMultiPatAlready?.length === 0 &&
								selectedId != '' &&
								!inactiveAddCharge === true &&
								!inactiveMultipleRows?.length > 0 ? (
								<span>
									{patName}{' '}
									{/* {patName &&
										`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
									- Already Add in {addFavListName}{' '}
								</span>
							) : (
								[]
							)}
							{patAlreadListName === true && errorFavPatAlready?.length == 0 ? (
								<span>{patAlreadyFavList} List Already Exist</span>
							) : (
								[]
							)}
							{errorMultiPatAlready?.length !== 0 &&
								selectedId != '' &&
								!inactiveMultipleRows?.length > 0 ? (
								<span>
									{errorMultiPatAlready?.map((i, index) => {
										// const [lastName, firstName] =
										// 	i?.CodeDescription.split(', ');
										// const formattedName = `${firstName.trim()}, ${lastName.trim()}`;
										return (
											<span key={index}>
												{i?.CodeDescription}
												{index !== errorMultiPatAlready?.length - 1
													? ' - '
													: ''}
											</span>
										);
									})}{' '}
									- Already Add in {addFavListName}{' '}
								</span>
							) : (
								[]
							)}

							{inactiveAddCharge === true &&
								!inactiveMultipleRows?.length > 0 ? (
								<span>
									{patName + ' '}
									{/* {patName &&
										`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
									- is Inactive status
								</span>
							) : (
								[]
							)}
							{inactiveMultipleRows?.length > 0 ? (
								<span>
									{inactiveMultipleRows?.map((i, index) => {
										const [lastName, firstName] = i?.Name.split(', ');
										const formattedName = `${firstName.trim()}, ${lastName.trim()}`;
										return (
											<span key={index}>
												{formattedName}
												{index !== inactiveMultipleRows?.length - 1
													? ' - '
													: ''}
											</span>
										);
									})}{' '}
									is Inactive status You can uncheck{' '}
									{inactiveMultipleRows?.map((i, index) => {
										const [lastName, firstName] = i?.Name.split(', ');
										const formattedName = `${firstName.trim()}, ${lastName.trim()}`;
										return (
											<span key={index}>
												{formattedName}
												{index !== inactiveMultipleRows?.length - 1
													? ' - '
													: ''}
											</span>
										);
									})}
								</span>
							) : (
								[]
							)}
						</Box>
					</DialogContent>
				</Dialog>

				{/* Add Appointment Dialogue for cancel & yes */}
				<Dialog
					fullScreen={fullScreen}
					open={AppointmentPopup}
					onClose={closePopup}
					aria-labelledby="responsive-dialog-title"
					PaperProps={{
						sx: {
							...patientModalPaperSx,
							width: 'min(420px, calc(100vw - 32px))',
							m: 0,
						},
					}}
				>
					{patientModalHeader('Confirmation', deleteCancelPopup)}
					<DialogContent sx={{ px: 3, pt: 3, pb: 2 }}>
						<Typography
							textAlign="center"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 600,
								fontSize: '14px',
								color: '#0b2450',
							}}
						>
							Do you want to Add Appointment -{' '}
							<span
								style={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '14px',
									color: '#075AD7',
								}}
							>
								{appointmentPatientName}
							</span>{' '}
							?
						</Typography>
					</DialogContent>
					<Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, borderTop: '1px solid #edf2f8', px: 2.4, py: 1.5 }}>
						<Button
							startIcon={<CancelIcon sx={{ fontSize: '18px' }} />}
							sx={patientModalOutlineButtonSx}
							variant="contained"
							size="small"
							autoFocus
							onClick={closePopup}
						>
							No
						</Button>
						<Button
							startIcon={<DomainVerificationIcon sx={{ fontSize: '18px' }} />}
							sx={patientModalPrimaryButtonSx}
							variant="contained"
							size="small"
							onClick={SubmitAppointment}
							autoFocus
						>
							Yes
						</Button>
					</Box>
				</Dialog>

				{/* Add Appointment Modal Section Start  */}

				<Modal
					open={open}
					onClose={handleCloseAppointment}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						{patientModalHeader('Add Appointment', handleCloseModal)}
						<Box sx={{ p: 2.4 }}>
							<Box
								sx={{
									display: 'grid',
									gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
									gap: 1.6,
								}}
							>
								<Box>
									<Typography sx={patientModalLabelSx}>Patient Name</Typography>
									<FormControl fullWidth size="small" sx={patientModalFieldSx}>
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											displayEmpty
											placeholder="appoitnmetn patient"
											value={appointmentPatientId}
										>
											<MenuItem value={appointmentPatientId} style={{ width: '100%' }} disabled>
												{appointmentPatientName}
											</MenuItem>
										</Select>
									</FormControl>
								</Box>
								<Box>
									<Typography sx={patientModalLabelSx}>Provider Name</Typography>
									{appointmentProviderId?.length > 0 ? (
										<FormControl fullWidth size="small" sx={patientModalFieldSx}>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												displayEmpty
												placeholder="Provider Name"
												value={appointmentProviderId}
											>
												<MenuItem value={appointmentProviderId} style={{ width: '100%' }} disabled>
													{appointmentProviderName}
												</MenuItem>
											</Select>
										</FormControl>
									) : (
										<FormControl fullWidth size="small" sx={patientModalFieldSx}>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												displayEmpty
												placeholder="Provider Name"
												value={selectAppointmentProvider}
												onChange={(e) => {
													setSelectAppointmentProvider(e.target.value);
												}}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '200px',
															overflowY: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
											>
												<MenuItem value={''}>Select provider</MenuItem>

												{providers?.map((items, i) => {
													return (
														<MenuItem value={items?.id} key={i}>
															{items?.Fname + ',' + items?.Lname}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									)}
								</Box>
								<Box>
									<Typography sx={patientModalLabelSx}>Appointment Status</Typography>
									<FormControl fullWidth size="small" sx={patientModalFieldSx}>
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											displayEmpty
											placeholder="Appoiintment Status"
											value={selectedValueAppointment}
											onChange={handleChange}
											MenuProps={{
												PaperProps: {
													style: {
														maxHeight: '200px',
														overflowY: 'auto',
														scrollbarWidth: 'thin',
														scrollbarColor: 'dark',
														msOverflowStyle: 'none',
														WebkitOverflowScrolling: 'touch',
													},
												},
											}}
										>
											<MenuItem value="C">Completed</MenuItem>
											<MenuItem value="D">Dismissed</MenuItem>
											<MenuItem value="O">Other</MenuItem>
											<MenuItem value="P">Pending</MenuItem>
										</Select>
									</FormControl>
								</Box>
								<Box sx={{ gridColumn: { xs: 'auto', md: 'span 1' } }}>
									<Typography sx={patientModalLabelSx}>Location</Typography>
									{appointmentLocationName?.length > 0 ? (
										<FormControl fullWidth size="small" sx={patientModalFieldSx}>
											<Select
												labelId="location"
												id="location"
												displayEmpty
												value={appointmentLocationId}
												name="location"
											>
												<MenuItem value={appointmentLocationId} style={{ width: '100%' }} disabled>
													{appointmentLocationName}
												</MenuItem>
											</Select>
										</FormControl>
									) : (
										<FormControl fullWidth size="small" sx={patientModalFieldSx}>
											<Select
												labelId="location"
												id="location"
												name="location"
												displayEmpty
												placeholder="Location Name"
												value={selectAppointmentLocation}
												onChange={(e) => {
													setSelectAppointmentLocation(e.target.value);
												}}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '200px',
															overflowY: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
											>
												<MenuItem value={''}>Select location</MenuItem>
												{locationGet?.map((items, i) => {
													return (
														<MenuItem value={items?.id} key={i}>
															{items?.Name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									)}
								</Box>
								<Box sx={{ gridColumn: { xs: 'auto', md: 'span 2' } }}>
									<Typography sx={patientModalLabelSx}>Appointment Date Time</Typography>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DateTimePicker
											size="small"
											slotProps={{
												textField: {
													size: 'small',
													fullWidth: true,
													sx: patientModalFieldSx,
												},
											}}
											sx={{ width: '100%' }}
											value={selectedDate}
											onChange={(nValue) => {
												setselectedDate(nValue);
											}}
										/>
									</LocalizationProvider>
								</Box>
								<Box sx={{ gridColumn: '1 / -1' }}>
									<Typography sx={patientModalLabelSx}>Reason</Typography>
									<textarea
										name="Reason"
										value={AppointmentReason}
										onChange={(e) => setAppointmentReason(e.target.value)}
										placeholder="Enter Reason..."
										rows={3}
										style={{
											width: '100%',
											minHeight: '86px',
											resize: 'vertical',
											border: '1px solid #d7e3f4',
											borderRadius: '6px',
											padding: '10px 12px',
											boxSizing: 'border-box',
											fontFamily: 'Poppins',
											fontSize: '13px',
											color: '#0b2450',
											outline: 'none',
										}}
									/>
								</Box>
							</Box>
							{appointmentInactiveStatus === true ? (
								<Box
									sx={{
										mt: 1.5,
										backgroundColor: '#fff5f5',
										border: '1px solid #fecaca',
										borderRadius: '6px',
										color: '#b42318',
										fontFamily: 'Poppins',
										fontSize: '12px',
										fontWeight: 600,
										textAlign: 'center',
										p: 1,
									}}
								>
									Appointment cannot be created due to Inactive Patient
								</Box>
							) : (
								''
							)}

							{(appointmentProviderId === null &&
								AppointmentReason?.length === 0) ||
								(appointmentProviderId === null &&
									selectAppointmentProvider === '') ||
								(appointmentLocationId === null &&
									selectAppointmentLocation === '') ? (
								<Box
									sx={{
										mt: 1.5,
										backgroundColor: '#fff5f5',
										border: '1px solid #fecaca',
										borderRadius: '6px',
										color: '#b42318',
										fontFamily: 'Poppins',
										fontSize: '12px',
										fontWeight: 600,
										textAlign: 'center',
										p: 1,
									}}
								>
									Must Fill All Fields
								</Box>
							) : (
								''
							)}
						</Box>
						<Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, borderTop: '1px solid #edf2f8', px: 2.4, py: 1.5 }}>
							<Button
								startIcon={<CancelIcon sx={{ fontSize: '18px' }} />}
								onClick={handleCloseModal}
								sx={patientModalOutlineButtonSx}
							>
								Cancel
							</Button>

							<Button
								disabled={
									appointmentPatientId === ''
										? true
										: appointmentProviderId === ''
											? true
											: AppointmentReason === ''
												? true
												: appointmentLocationId === ''
													? true
													: appointmentInactiveStatus === true
														? true
														: appointmentProviderId === null &&
															selectAppointmentProvider === ''
															? true
															: appointmentLocationId === null &&
																selectAppointmentLocation === ''
																? true
																: false
								}
								startIcon={<DomainVerificationIcon sx={{ fontSize: '18px' }} />}
								sx={patientModalPrimaryButtonSx}
								onClick={SubmitAppointment}
							>
								Create Appointment
							</Button>
						</Box>
						<Box sx={{ display: 'none' }}>
							<Grid container>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Typography
										id="modal-modal-title"
										variant="h6"
										component="h2"
										sx={{
											textAlign: 'left',
											fontWeight: '500',
											marginLeft: '15px',
											fontFamily: 'Poppins',
										}}
									>
										Add Appointment
									</Typography>
								</Grid>
							</Grid>
							<Box
								sx={{
									textAlign: 'right',
									marginTop: '-1.8rem',
									marginLeft: '15px',
								}}
							>
								<CancelIcon
									sx={{
										fontSize: '24px',
										color: 'red',
										cursor: 'pointer',
									}}
									onClick={handleCloseModal}
								/>
							</Box>

							<Grid
								container
								xs={12}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								sx={{ marginTop: '1rem' }}
							>
								<Grid container item xs={12} sm={6} md={6} lg={6} xl={6}>
									<Grid item xs={12} sm={11} md={11} lg={11} xl={11}>
										<Grid
											item
											xs={12}
											lg={12}
											md={12}
											sm={12}
											xl={12}
											sx={{
												padding: ' 3px 13px',
											}}
										>
											<Typography
												variant="body1"
												sx={{
													fontFamily: 'Poppins',
													fontSize: {
														xl: '14px',
														lg: '14px',
														md: '14px',
														sm: '12px',
														xs: '14px',
													},
													fontWeight: '500',
												}}
											>
												Patient Name
											</Typography>
											<FormControl
												fullWidth
												sx={{
													border: '1px solid #00000026',
													boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
													borderRadius: '4px',
												}}
											>
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													placeholder="appoitnmetn patient"
													value={appointmentPatientId}
												>
													<MenuItem
														value={appointmentPatientId}
														style={{ width: '100%' }}
														disabled
														selected
													>
														{appointmentPatientName}
													</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									</Grid>
									<Grid
										item
										xs={12}
										sm={11}
										md={11}
										lg={11}
										xl={11}
										sx={{
											padding: '8px 13px',
										}}
									>
										<Typography
											variant="body2"
											sx={{
												color: '#333',
												fontSize: {
													xl: '14px',
													lg: '14px',
													md: '14px',
													sm: '12px',
													xs: '14px',
												},
												fontFamily: 'Poppins',
												fontWeight: '500',
											}}
										>
											Reason
										</Typography>
										<TextField
											multiline
											fullWidth
											name="Reason"
											rows={3}
											sx={{
												borderRadius: '6px',
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
											}}
											value={AppointmentReason}
											onChange={(e) => setAppointmentReason(e.target.value)}
										/>
									</Grid>
								</Grid>

								<Grid item container xs={12} sm={6} md={6} lg={6} xl={6}>
									<Grid
										item
										xs={12}
										sm={5.5}
										md={5.5}
										lg={5.5}
										xl={5.5}
										sx={{ margin: '5px' }}
									>
										<Typography
											variant="body2"
											sx={{
												color: '#333',
												fontSize: {
													xl: '14px',
													lg: '14px',
													md: '14px',
													sm: '12px',
													xs: '14px',
												},
												fontFamily: 'Poppins',
												fontWeight: '500',
											}}
										>
											Provider Name
										</Typography>

										{appointmentProviderId?.length > 0 ? (
											<FormControl
												fullWidth
												sx={{
													border: '1px solid #00000026',
													boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
													borderRadius: '4px',
												}}
											>
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													placeholder="Provider Name"
													value={appointmentProviderId}
												>
													<MenuItem
														value={appointmentProviderId}
														style={{ width: '100%' }}
														disabled
														selected
													>
														{appointmentProviderName}
													</MenuItem>
												</Select>
											</FormControl>
										) : (
											<FormControl
												fullWidth
												sx={{
													border: '1px solid #00000026',
													boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
													borderRadius: '4px',
												}}
											>
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													placeholder="Provider Name"
													value={selectAppointmentProvider}
													onChange={(e) => {
														setSelectAppointmentProvider(e.target.value);
													}}
													MenuProps={{
														PaperProps: {
															style: {
																height: '160px',
																overflowY: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem value={''}>Clear Filter</MenuItem>

													{providers?.map((items, i) => {
														return (
															<MenuItem value={items?.id} key={i}>
																{items?.Fname + ',' + items?.Lname}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										)}
									</Grid>
									<Grid
										item
										xs={12}
										sm={5.5}
										md={5.5}
										lg={5.5}
										xl={5.5}
										sx={{ margin: '5px' }}
									>
										<Typography
											variant="body2"
											sx={{
												color: '#333',
												fontSize: {
													xl: '13px',
													lg: '13px',
													md: '13px',
													sm: '13px',
													xs: '13px',
												},
												fontFamily: 'Poppins',
												fontWeight: '500',
											}}
										>
											Appointment Status
										</Typography>
										<FormControl
											fullWidth
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
												borderRadius: '4px',
											}}
										>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												placeholder="Appoiintment Status"
												value={selectedValueAppointment}
												onChange={handleChange}
												MenuProps={{
													PaperProps: {
														style: {
															height: '160px',
															overflowY: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
											>
												<MenuItem value="C">Completed</MenuItem>
												<MenuItem value="D">Dismissed</MenuItem>
												<MenuItem value="O">Other</MenuItem>
												<MenuItem value="P">Pending</MenuItem>
											</Select>
										</FormControl>
									</Grid>
									<Grid
										item
										xs={12}
										sm={5.5}
										md={5.5}
										lg={5.5}
										xl={5.5}
										sx={{ margin: '5px' }}
									>
										<Typography
											variant="body2"
											sx={{
												color: '#333',
												fontSize: {
													xl: '14px',
													lg: '14px',
													md: '14px',
													sm: '12px',
													xs: '14px',
												},
												fontFamily: 'Poppins',
												fontWeight: '500',
											}}
										>
											Location
										</Typography>
										{appointmentLocationName?.length > 0 ? (
											<FormControl fullWidth>
												<Select
													labelId="location"
													id="location"
													value={appointmentLocationId}
													name="location"
													sx={{ height: '45px', mt: 1 }}
												>
													<MenuItem
														value={appointmentLocationId}
														style={{ width: '100%' }}
														disabled
														selected
													>
														{appointmentLocationName}
													</MenuItem>
												</Select>
											</FormControl>
										) : (
											<FormControl fullWidth>
												<Select
													labelId="location"
													id="location"
													name="location"
													sx={{ height: '45px', mt: 1 }}
													placeholder="Location Name"
													value={selectAppointmentLocation}
													onChange={(e) => {
														setSelectAppointmentLocation(e.target.value);
													}}
													MenuProps={{
														PaperProps: {
															style: {
																height: '160px',
																overflowY: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem value={''}>Clear Filter</MenuItem>
													{locationGet?.map((items, i) => {
														return (
															<MenuItem value={items?.id} key={i}>
																{items?.Name}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										)}
									</Grid>
									<Grid
										item
										xs={12}
										sm={5.5}
										md={5.5}
										lg={5.5}
										xl={5.5}
										sx={{ margin: '5px' }}
									>
										<Typography
											variant="body2"
											sx={{
												color: '#333',
												fontSize: {
													xl: '14px',
													lg: '14px',
													md: '14px',
													sm: '11px',
													xs: '14px',
												},
												fontFamily: 'Poppins',
												fontWeight: '500',
											}}
										>
											Appointment Date Time
										</Typography>
										<LocalizationProvider dateAdapter={AdapterDayjs}>
											<DemoContainer components={['DateTimePicker']}>
												<DemoItem>
													<DateTimePicker
														// disablePast
														size="small"
														slotProps={{ textField: { size: 'small' } }}
														sx={{
															boxShadow: '1px 1px 10px #79ACF178 inset',
															width: {
																xl: '400px',
																lg: '220px',
																md: '180px',
																sm: '140px',
																xs: '425px',
															},
														}}
														value={selectedDate}
														onChange={(nValue) => {
															setselectedDate(nValue);
														}}
													/>
												</DemoItem>
											</DemoContainer>
										</LocalizationProvider>
									</Grid>
								</Grid>
							</Grid>
							<Grid
								item
								sx={{
									display: 'flex',
									justifyContent: 'flex-end',
									gap: '5px',
									padding: '13px 8px 0px 8px',
								}}
								xs={12}
							>
								<Button
									onClick={handleCloseModal}
									sx={{
										background: '#ED2828',
										border: '2px solid #ED2828',
										color: 'white',
										fontFamily: 'Poppins',
										fontSize: '15px',
										fontWeight: '500',
										padding: '7px 15px',
										'&:hover': {
											border: '2px solid #ED2828',
											color: '#ED2828',
										},
									}}
								>
									Cancel
								</Button>

								<Button
									disabled={
										appointmentPatientId === ''
											? true
											: appointmentProviderId === ''
												? true
												: AppointmentReason === ''
													? true
													: appointmentLocationId === ''
														? true
														: appointmentInactiveStatus === true
															? true
															: appointmentProviderId === null &&
																selectAppointmentProvider === ''
																? true
																: appointmentLocationId === null &&
																	selectAppointmentLocation === ''
																	? true
																	: false
									}
									sx={{
										background: '#FD7702',
										border: '2px solid #e87511',
										color: 'white',
										fontFamily: 'Poppins',
										fontSize: '15px',
										fontWeight: '500',
										padding: '7px 15px',
										'&:hover': {
											border: '2px solid #e87511',
											color: '#e87511',
										},
									}}
									onClick={SubmitAppointment}
								>
									Create Appointment
								</Button>
							</Grid>
							{appointmentInactiveStatus === true ? (
								<Box
									sx={{
										textAlign: 'center',
										marginTop: '1rem',
										backgroundColor: '#ED2828',
									}}
								>
									<span
										style={{
											color: 'white',
											fontFamily: 'Poppins',
											fontSize: '15px',
											fontWeight: '500',
										}}
									>
										Appointment cannot be created due to Inactive Patient
									</span>
								</Box>
							) : (
								''
							)}

							{(appointmentProviderId === null &&
								AppointmentReason?.length === 0) ||
								(appointmentProviderId === null &&
									selectAppointmentProvider === '') ||
								(appointmentLocationId === null &&
									selectAppointmentLocation === '') ? (
								<Box
									sx={{
										textAlign: 'center',
										marginTop: '1rem',
										backgroundColor: '#ED2828',
									}}
								>
									<span
										style={{
											color: 'white',
											fontFamily: 'Poppins',
											fontSize: '15px',
											fontWeight: '500',
										}}
									>
										Must Fill All Fields
									</span>
								</Box>
							) : (
								''
							)}
						</Box>
					</Box>
				</Modal>

				{/* Snackbar for Alert Already Inactive Status */}

				<Snackbar
					open={inactivePopup}
					onClose={CancelSnackbarInactive}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelSnackbarInactive}
						severity="success"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelSnackbarInactive}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '16px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{patName + ' '}
						{/* {patName &&
							`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
						is Activated Successfully !
					</Alert>
				</Snackbar>

				{/* Snackbar for Activate Inactive Status */}

				<Snackbar
					open={activeInactive}
					onClose={CancelSnackbarActivate}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelSnackbarActivate}
						severity="error"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelSnackbarActivate}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '16px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{patName + ' '}
						{/* {patName &&
							`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
						has been deactivated !
					</Alert>
				</Snackbar>

				{/* Snackbar for Add Patient Admission */}

				<Snackbar
					open={snackAddPatAdm}
					onClose={CancelSnackbarAddPatAdm}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelSnackbarAddPatAdm}
						severity="success"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelSnackbarAddPatAdm}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '14px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						Admission created Successfully !
					</Alert>
				</Snackbar>

				{/* Snackbar for Add Favourite Patient */}

				<Snackbar
					open={snackAddFavPat}
					onClose={CancelSnackbarAddFavPat}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelSnackbarAddFavPat}
						severity="success"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelSnackbarAddFavPat}
									style={{
										cursor: 'pointer',
										marginTop: '-.4rem',
										fontSize: '14px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									close
								</span>
							</React.Fragment>
						}
					>
						{/* {patName}  */}
						{/* {patName &&
							`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
						Successfully Patient Added into Favourite List !
					</Alert>
				</Snackbar>
				{/* Snackbar for Delete Favourite Patient */}

				<Snackbar
					open={snackDeleteFavPat}
					onClose={CancelSnackbarDeleteFavPat}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelSnackbarDeleteFavPat}
						severity="success"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelSnackbarDeleteFavPat}
									style={{
										cursor: 'pointer',
										marginTop: '-.5rem',
										fontSize: '14px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									close
								</span>
							</React.Fragment>
						}
					>
						Successfully deleted patient from Favourite List!
						{/* {patName}  */}
						{/* {patName &&
							`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
						{/* from&nbsp; {favListName?.SettingName} ! */}
					</Alert>
				</Snackbar>

				{/* Snackbar for Delete Patient */}

				<Snackbar
					open={deletePopup}
					onClose={CancelSnackbarDelete}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelSnackbarDelete}
						severity="success"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelSnackbarDelete}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '16px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{patName + ' '}
						{/* {patName &&
							`${patName.split(',')[1].trim()}, ${patName.split(',')[0].trim()}`} */}
						has been deleted Successfully
					</Alert>
				</Snackbar>

				{/* Snackbar for Add Appointment */}

				<Snackbar
					open={AddAppointmentPopup}
					onClose={CancelSnackbarAppointment}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelSnackbarAppointment}
						severity="success"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelSnackbarAppointment}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '16px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						Appointment Created Successfully
					</Alert>
				</Snackbar>

				<Snackbar
					open={ErrorAppointmentPopup}
					onClose={CancelSnackbarAppointment}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelSnackbarAppointment}
						severity="error"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelSnackbarAppointment}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '16px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						Appointment cannot be created due to empty fields
					</Alert>
				</Snackbar>
			</Box>
		</>
	);
}

export default PatientList;
